import store from "../controller/baseController";
import Enums from "../enums/enums";
import peakUtility from "../function/peakUtility.js";
import i18n from "../locales/i18n";
import {
  GetCreateAllocationTransaction,
  GetCreateAllocationTransactionItem,
} from "../service/transaction/transactionHelper";
import paymentHelper from "./paymentHelper";
import { GetCalculatedPartialQuotationItemTypePercent } from "./transactionCreateAndEditHelper";
import userHelper from "./userHelper";
const vatPercent = 7;
const inputMaxNumber = 999999999.9999;
const inputMinNumber = -999999999.9999;
const inputTotalDigit = 15;
export const GetMaxAllocationShowByPackage = (isJournal = false) => {
  let maxAllocationShow = isJournal ? 8 : 4;
  if (userHelper.CheckMerchantPackage([Enums.Package.Free])) {
    maxAllocationShow = 0;
  } else if (userHelper.CheckMerchantPackage([Enums.Package.Basic])) {
    maxAllocationShow = isJournal ? 2 : 1;
  } else if (userHelper.CheckMerchantPackage([Enums.Package.Pro])) {
    maxAllocationShow = isJournal ? 4 : 2;
  }
  return maxAllocationShow;
};
export const GetMaxAllocationCanInsert = (isJournal = false) => {
  let maxAllocationCanInsert = Infinity;
  if (userHelper.CheckMerchantPackage([Enums.Package.Free])) {
    maxAllocationCanInsert = 0;
  } else if (userHelper.CheckMerchantPackage([Enums.Package.Basic])) {
    maxAllocationCanInsert = isJournal ? 2 : 1;
  } else if (userHelper.CheckMerchantPackage([Enums.Package.Pro])) {
    maxAllocationCanInsert = isJournal ? 4 : 2;
  }
  return maxAllocationCanInsert;
};

export const GetMaxAllocationItemCanInsert = () => {
  let maxAllocationItemCanInsert = Infinity;
  if (userHelper.CheckMerchantPackage([Enums.Package.Free])) {
    maxAllocationItemCanInsert = 0;
  } else if (userHelper.CheckMerchantPackage([Enums.Package.Basic])) {
    maxAllocationItemCanInsert = 1;
  } else if (userHelper.CheckMerchantPackage([Enums.Package.Pro])) {
    maxAllocationItemCanInsert = 1;
  }
  return maxAllocationItemCanInsert;
};

function SetFullReferenceInvoiceReceiptSummary(transactionReferenceTransactionModel, referenceTransaction) {
  transactionReferenceTransactionModel.fromCurrencyWHTTotal = referenceTransaction.remainingFromCurrencyWHTTotal;
  transactionReferenceTransactionModel.fromCurrencyNetTotal = referenceTransaction.remainingFromCurrencyNetTotal;
  transactionReferenceTransactionModel.fromCurrencyVatTotal = referenceTransaction.remainingFromCurrencyVatTotal;
  transactionReferenceTransactionModel.fromCurrencyPreVatTotal = referenceTransaction.remainingFromCurrencyPreVatTotal;
  transactionReferenceTransactionModel.fromCurrencyZeroVatTotal =
    referenceTransaction.remainingFromCurrencyZeroVatTotal;
  transactionReferenceTransactionModel.fromCurrencyVatExemptedTotal =
    referenceTransaction.remainingFromCurrencyVatExemptedTotal;
  transactionReferenceTransactionModel.fromCurrencySubTotalForcalculateWHT =
    referenceTransaction.remainingFromCurrencySubTotalForcalculateWHT;
  transactionReferenceTransactionModel.toCurrencyWHTTotal = referenceTransaction.remainingToCurrencyWHTTotal;
  transactionReferenceTransactionModel.toCurrencyNetTotal = referenceTransaction.remainingToCurrencyNetTotal;
  transactionReferenceTransactionModel.toCurrencyVatTotal = referenceTransaction.remainingToCurrencyVatTotal;
  transactionReferenceTransactionModel.toCurrencyPreVatTotal = referenceTransaction.remainingToCurrencyPreVatTotal;
  transactionReferenceTransactionModel.toCurrencyZeroVatTotal = referenceTransaction.remainingToCurrencyZeroVatTotal;
  transactionReferenceTransactionModel.toCurrencyVatExemptedTotal =
    referenceTransaction.remainingToCurrencyVatExemptedTotal;
  transactionReferenceTransactionModel.toCurrencySubTotalForcalculateWHT =
    referenceTransaction.remainingToCurrencySubTotalForcalculateWHT;
}
function SetReferenceInvoiceReceiptSummary(transactionReferenceTransactionModel) {
  const summaryRefTransaction = {};
  transactionReferenceTransactionModel.transactionItemList.forEach((item) => {
    (summaryRefTransaction.fromCurrencyWHTTotal =
      (summaryRefTransaction.fromCurrencyWHTTotal ?? 0) + item.fromCurrencyWHTTotal),
      (summaryRefTransaction.fromCurrencyNetTotal =
        (summaryRefTransaction.fromCurrencyNetTotal ?? 0) + item.fromCurrencyNetTotal),
      (summaryRefTransaction.fromCurrencyVatTotal =
        (summaryRefTransaction.fromCurrencyVatTotal ?? 0) + item.fromCurrencyVatTotal),
      (summaryRefTransaction.fromCurrencyPreVatTotal =
        (summaryRefTransaction.fromCurrencyPreVatTotal ?? 0) + item.fromCurrencyPreVatTotal),
      (summaryRefTransaction.fromCurrencyZeroVatTotal =
        (summaryRefTransaction.fromCurrencyZeroVatTotal ?? 0) + item.fromCurrencyZeroVatTotal),
      (summaryRefTransaction.fromCurrencyVatExemptedTotal =
        (summaryRefTransaction.fromCurrencyVatExemptedTotal ?? 0) + item.fromCurrencyVatExemptedTotal),
      (summaryRefTransaction.fromCurrencySubTotalForcalculateWHT =
        (summaryRefTransaction.fromCurrencySubTotalForcalculateWHT ?? 0) + item.fromCurrencySubTotalForcalculateWHT),
      (summaryRefTransaction.toCurrencyWHTTotal =
        (summaryRefTransaction.toCurrencyWHTTotal ?? 0) + item.toCurrencyWHTTotal),
      (summaryRefTransaction.toCurrencyNetTotal =
        (summaryRefTransaction.toCurrencyNetTotal ?? 0) + item.toCurrencyNetTotal),
      (summaryRefTransaction.toCurrencyVatTotal =
        (summaryRefTransaction.toCurrencyVatTotal ?? 0) + item.toCurrencyVatTotal),
      (summaryRefTransaction.toCurrencyPreVatTotal =
        (summaryRefTransaction.toCurrencyPreVatTotal ?? 0) + item.toCurrencyPreVatTotal),
      (summaryRefTransaction.toCurrencyZeroVatTotal =
        (summaryRefTransaction.toCurrencyZeroVatTotal ?? 0) + item.toCurrencyZeroVatTotal),
      (summaryRefTransaction.toCurrencyVatExemptedTotal =
        (summaryRefTransaction.toCurrencyVatExemptedTotal ?? 0) + item.toCurrencyVatExemptedTotal),
      (summaryRefTransaction.toCurrencySubTotalForcalculateWHT =
        (summaryRefTransaction.toCurrencySubTotalForcalculateWHT ?? 0) + item.toCurrencySubTotalForcalculateWHT);
  });
  transactionReferenceTransactionModel.fromCurrencyWHTTotal = summaryRefTransaction.fromCurrencyWHTTotal;
  transactionReferenceTransactionModel.fromCurrencyNetTotal = summaryRefTransaction.fromCurrencyNetTotal;
  transactionReferenceTransactionModel.fromCurrencyVatTotal = summaryRefTransaction.fromCurrencyVatTotal;
  transactionReferenceTransactionModel.fromCurrencyPreVatTotal = summaryRefTransaction.fromCurrencyPreVatTotal;
  transactionReferenceTransactionModel.fromCurrencyZeroVatTotal = summaryRefTransaction.fromCurrencyZeroVatTotal;
  transactionReferenceTransactionModel.fromCurrencyVatExemptedTotal =
    summaryRefTransaction.fromCurrencyVatExemptedTotal;
  transactionReferenceTransactionModel.fromCurrencySubTotalForcalculateWHT =
    summaryRefTransaction.fromCurrencySubTotalForcalculateWHT;
  transactionReferenceTransactionModel.toCurrencyWHTTotal = summaryRefTransaction.toCurrencyWHTTotal;
  transactionReferenceTransactionModel.toCurrencyNetTotal = summaryRefTransaction.toCurrencyNetTotal;
  transactionReferenceTransactionModel.toCurrencyVatTotal = summaryRefTransaction.toCurrencyVatTotal;
  transactionReferenceTransactionModel.toCurrencyPreVatTotal = summaryRefTransaction.toCurrencyPreVatTotal;
  transactionReferenceTransactionModel.toCurrencyZeroVatTotal = summaryRefTransaction.toCurrencyZeroVatTotal;
  transactionReferenceTransactionModel.toCurrencyVatExemptedTotal = summaryRefTransaction.toCurrencyVatExemptedTotal;
  transactionReferenceTransactionModel.toCurrencySubTotalForcalculateWHT =
    summaryRefTransaction.toCurrencySubTotalForcalculateWHT;
}
function GetPageTransactionItemByPageSize(indexTransactionItem, pageSize) {
  let pageNo = parseInt(indexTransactionItem / pageSize);
  pageNo += indexTransactionItem % pageSize > 0 ? 1 : 0;
  return pageNo;
}
function GetPageErrorListfromTransaction(transaction) {
  let pageErrorList = [];
  if (transaction && transaction.transactionItemList && transaction.transactionItemList.length > 0) {
    transaction.transactionItemList.forEach((transactionItem, index) => {
      let sequenceNumber = index + 1;
      if (transactionItem.isValidateError || transactionItem.description.validateError) {
        let page = GetPageTransactionItemByPageSize(sequenceNumber, transaction.pageSize);
        let selectPageError = pageErrorList.find((x) => x.page === page);
        if (selectPageError) {
          selectPageError.sequenceNumberList.push(sequenceNumber);
        } else {
          pageErrorList.push({ page: page, sequenceNumberList: [sequenceNumber] });
        }
      }
    });
  }
  return pageErrorList;
}
function SlideToElementError(transaction) {
  let numberValidateError = transaction.number.validateError;
  let referenceValidateError = transaction.reference.validateError;
  let transactionListValidateError = transaction.isValidateError;
  let contactValidateError = transaction.contact.validateError || transaction.contact.id === 0;
  let dateValidateError = !transaction.date.value || transaction.date.value === "";
  let dueDateValidateError = false;
  let transactionCurrencySummaryVatIsActive = false;
  let returnStockTypeValidateError = false;
  let reasonDescriptionValidateError = false;
  let reasonTypeValidateError = false;
  let receivedTaxInvoiceValidateError = transaction.receivedTaxInvoice
    ? transaction.receivedTaxInvoice.validateError
    : false;
  if (
    transaction.transactionType == Enums.TransactionType.CreditNote ||
    transaction.transactionType == Enums.TransactionType.DebitNote
  ) {
    returnStockTypeValidateError = transaction.returnStock.validateError || transaction.returnStock.value.id == 0;
    reasonDescriptionValidateError =
      transaction.reasonDescription.validateError ||
      transaction.reasonDescription.text == null ||
      transaction.reasonDescription.text.trim() == "";
    reasonTypeValidateError = transaction.reasonType.value == null || transaction.reasonType.value.id == 0;
  }
  if (
    transaction.transactionType === Enums.TransactionType.Invoice ||
    transaction.transactionType === Enums.TransactionType.Quotation
  ) {
    dueDateValidateError =
      !transaction.dueDate.value || transaction.dueDate.value === "" || transaction.dueDate.validateError;
  }

  if (transaction.transactionCurrencySummary.vat) {
    transactionCurrencySummaryVatIsActive = transaction.transactionCurrencySummary.vat.isActive;
  }
  let netAmountValidateError = transaction.transactionSummary.netAmount.ToNumber() < 0 ? true : false;
  let paymentValidateError = transaction.payment ? transaction.payment.isValidateError : false;
  let remarkValidateError = transaction.remark.text ? transaction.remark.validateError : false;
  let elementId = "";

  if (numberValidateError || referenceValidateError || receivedTaxInvoiceValidateError) {
    elementId = "headPage";
  } else if (contactValidateError || dateValidateError || dueDateValidateError) {
    elementId = "contactInformation";
  } else if (transactionListValidateError) {
    elementId = "dataList";
  } else if (transactionCurrencySummaryVatIsActive) {
    elementId = "dataSummary";
  } else if (paymentValidateError) {
    AlertPaymentValidateError(transaction);
    elementId = "PaymentGatewayEditDocument";
  } else if (remarkValidateError) {
    elementId = "RecordExternal";
  } else if (returnStockTypeValidateError || reasonDescriptionValidateError || reasonTypeValidateError) {
    elementId = "creditNoteDebitNoteReasonEditDocument";
  }
  if (document.getElementById(elementId)) {
    document.getElementById(elementId).scrollIntoView({ behavior: "smooth", block: "center" });
  }
}
function AlertPaymentValidateError(transaction) {
  let paymentAllGroupTotal = transaction.payment.paymentAllGroupTotal.ToNumber().ToAccountingRoundUpNumber();
  let netAmount = transaction.transactionSummary.remainPaymentNetAmount.ToNumber().ToAccountingRoundUpNumber();

  if (
    (transaction.transactionType === Enums.TransactionType.Receipt &&
      transaction.financeType === Enums.FinanceType.InFlow) ||
    (transaction.transactionType === Enums.TransactionType.CreditNote && transaction.reference.referenceId > 0) ||
    transaction.transactionType === Enums.TransactionType.BillingNote
  ) {
    if (paymentAllGroupTotal !== netAmount) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Total_Payment_Must_Be_Equal_To_Net_Amount"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }
  }
}
function TransactionValidationAndRemoveTransactionItemEmpty(
  transaction,
  triggerAlert = true,
  isImportTransaction = false
) {
  return TransactionValidationAndRemoveTransactionItemEmptyBase(transaction, triggerAlert, isImportTransaction, false);
}
function BookmarkValidation(transaction) {
  CheckErrorValueInput(transaction);
  return TransactionValidationAndRemoveTransactionItemEmptyBase(transaction, true, false, true);
}
function CheckTransactionItemIsNotEmpty(transaction) {
  let transactionItemIsCheck = false;

  if (transaction && transaction.transactionItemList && transaction.transactionItemList.length > 0) {
    transactionItemIsCheck = transaction.transactionItemList.some(
      (transactionItem) => transactionItem.checked.value === true
    );
  }

  if (!transactionItemIsCheck) {
    store.dispatch("SetAlertMessage", {
      alertMessage: i18n.t("Please_Select_Product_Service_At_Least_One_Transaction"),
      typeMessage: Enums.TypeComponentNoti.error,
    });
  }

  return transactionItemIsCheck ? true : false;
}
function TransactionValidationInvoice(transaction) {
  let isTransactionItemValidate = true;

  if (
    transaction.transactionType == Enums.TransactionType.Invoice &&
    transaction.reference.referenceTypeId == Enums.TransactionType.Quotation &&
    transaction.reference.referenceId > 0
  ) {
    isTransactionItemValidate = CheckTransactionItemIsNotEmpty(transaction);
  }

  return isTransactionItemValidate;
}
function GetCreditNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
  return transactionReferenceAmount
    .ToNumber()
    .Subtract(vatExemptedTotal.ToNumber().Add(zeroVatTotal.ToNumber()).Add(preVatTotal.ToNumber()))
    .ToAccountingRoundUpNumber();
}
function GetDebitNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
  return transactionReferenceAmount
    .ToNumber()
    .Add(vatExemptedTotal.ToNumber())
    .Add(zeroVatTotal.ToNumber())
    .Add(preVatTotal.ToNumber())
    .ToAccountingRoundUpNumber();
}
function TransactionValidationDebitNoteCreditNote(transaction) {
  let isTransactionItemValidate = true;
  let isNewAmountValidate = true;
  if (
    (transaction.transactionType == Enums.TransactionType.CreditNote ||
      transaction.transactionType == Enums.TransactionType.DebitNote) &&
    transaction.reference.referenceId > 0
  ) {
    isTransactionItemValidate = CheckTransactionItemIsNotEmpty(transaction);
  }

  let totalDocumentAmountAfterCreditNote = 0;
  if (transaction.transactionType == Enums.TransactionType.CreditNote) {
    totalDocumentAmountAfterCreditNote = GetCreditNoteActualTotal(
      transaction.transactionReferenceAmount.value,
      transaction.transactionCurrencySummary.vatExemptedTotal,
      transaction.transactionCurrencySummary.zeroVatTotal,
      transaction.transactionCurrencySummary.vat.preVatTotal
    );
  } else if (transaction.transactionType == Enums.TransactionType.DebitNote) {
    totalDocumentAmountAfterCreditNote = GetDebitNoteActualTotal(
      transaction.transactionReferenceAmount.value,
      transaction.transactionCurrencySummary.vatExemptedTotal,
      transaction.transactionCurrencySummary.zeroVatTotal,
      transaction.transactionCurrencySummary.vat.preVatTotal
    );
  }

  if (totalDocumentAmountAfterCreditNote < 0) {
    isNewAmountValidate = false;
  }

  if (!isNewAmountValidate) {
    store.dispatch("SetAlertMessage", {
      alertMessage: i18n.t("New_Amount_Must_Be_Greater_Than_Or_Equal_To_0"),
      typeMessage: Enums.TypeComponentNoti.error,
    });
  }

  return isTransactionItemValidate && isNewAmountValidate;
}
export const ValidateBillingTransactionItem = (transactionItemList) => {
  if (!transactionItemList || transactionItemList.length === 0) {
    return true;
  }

  return transactionItemList.some((x) => x.billedToCurrencyAmount.ToNumber() <= 0);
};

export const ValidateTransactionAllocationValidateError = (transaction) => {
  const validateAllocationTransactionLimitError = ValidateAllocationTransactionLimitByPackage(transaction);
  const validateAllocationTransactionItemLimitError = ValidateAllocationTransactionItemLimitByPackage(transaction);

  return validateAllocationTransactionLimitError || validateAllocationTransactionItemLimitError;
};

export const ValidateAllocationTransactionLimitByPackage = (transaction) => {
  const maxAllocationCanInsert = GetMaxAllocationCanInsert();
  const maxAllocationItemCanInsert = GetMaxAllocationItemCanInsert();
  let validateAllocationTransactionLimitError = false;
  if (transaction.allocationTransactionList) {
    let countAllocation = 0;
    for (const allocationTransaction of transaction.allocationTransactionList) {
      let countAllocationItem = 0;

      if (allocationTransaction.allocationItemList && allocationTransaction.allocationItemList.length > 0) {
        for (const allocationItem of allocationTransaction.allocationItemList) {
          if (allocationItem.id > 0 && allocationItem.percent) {
            countAllocationItem++;
          }
        }
      }

      if (countAllocationItem > maxAllocationItemCanInsert) {
        validateAllocationTransactionLimitError = true;
      }

      if (countAllocationItem > 0) {
        countAllocation++;
      }

      if (countAllocation > maxAllocationCanInsert) {
        validateAllocationTransactionLimitError = true;
      }

      if (validateAllocationTransactionLimitError) {
        break;
      }
    }
  }
  return validateAllocationTransactionLimitError;
};

export const ValidateAllocationTransactionItemLimitByPackage = (transaction) => {
  const maxAllocationCanInsert = GetMaxAllocationCanInsert();
  let validateAllocationTransactionItemLimitError = false;
  if (maxAllocationCanInsert !== Infinity) {
    if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
      const allocationTransaction = GetAllocationListWithOutZeroPercent(
        GetCreateAllocationTransaction(transaction.allocationTransactionList)
      );
      for (const transactionItem of transaction.transactionItemList) {
        if (!transactionItem.isUseTransactionAllocation) {
          const allocationTransactionItem = GetAllocationListWithOutZeroPercent(
            GetCreateAllocationTransactionItem(transactionItem.allocationTransactionList)
          );
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            allocationTransaction,
            allocationTransactionItem
          );
          if (!allocationTransactionEquals) {
            validateAllocationTransactionItemLimitError = true;
            break;
          }
        }
      }
    }
  }
  return validateAllocationTransactionItemLimitError;
};

export const GetAllocationTransactionEquals = (allocationListInTransaction, allocationListInTransactionItem) => {
  let allocationTransactionEquals = true;
  if (allocationListInTransaction && allocationListInTransactionItem) {
    if (
      allocationListInTransaction.length == allocationListInTransactionItem.length &&
      allocationListInTransactionItem.length == 0
    ) {
      allocationTransactionEquals = true;
    } else {
      allocationTransactionEquals = CheckAllocationEqual(allocationListInTransaction, allocationListInTransactionItem);
      if (allocationTransactionEquals) {
        allocationTransactionEquals = CheckAllocationEqual(
          allocationListInTransactionItem,
          allocationListInTransaction
        );
      }
    }
  } else if (!allocationListInTransaction && !allocationListInTransactionItem) {
    allocationTransactionEquals = true;
  } else {
    allocationTransactionEquals = false;
  }
  return allocationTransactionEquals;
};

const ValidateTransactionCurrencySummaryDepositError = (transaction) => {
  if (
    transaction.referenceDepositSummary &&
    (transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber() > 0 ||
      transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber() > 0 ||
      transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber() > 0 ||
      transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber() > 0)
  ) {
    if (transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber() < 0) {
      return true;
    }
    if (transaction.transactionCurrencySummary.zeroVatTotal.ToNumber() < 0) {
      return true;
    }
    if (transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber() < 0) {
      return true;
    }
    if (transaction.transactionCurrencySummary.vat.vatTotal.ToNumber() < 0) {
      return true;
    }
  }
};

const ValidateTransactionLimitValueOverflow = (transaction) => {
  const { min, max } = GetMinMaxValueFromDigit(inputTotalDigit);

  if (IsTransactionLimitValueOverflow(transaction, min, max)) {
    return true;
  }

  if (
    transaction.transactionType !== Enums.TransactionType.BillingNote &&
    IsTransactionItemListLimitValueOverflow(transaction.transactionItemList, min, max)
  ) {
    return true;
  }
  return false;
};

export const ValidateTransactionIsHaveVatError = (transaction) => {
  if (transaction.transactionSummary.vat.vatTotal.ToNumber() == 0) {
    return false;
  }

  if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
    let transactionVatTotalError = true;
    for (const transactionItem of transaction.transactionItemList) {
      if (transactionItem.vatTypeId.value == Enums.ProductVatType.SevenPercent) {
        transactionVatTotalError = false;
        break;
      }
    }
    return transactionVatTotalError;
  }
  return true;
};

export const GetMinMaxValueFromDigit = (digit) => {
  const max = Math.pow(10, digit);
  const min = -max;
  return { min, max };
};

const IsTransactionLimitValueOverflow = (transaction, min, max) => {
  if (
    IsTransactionSummaryLimitValueOverflow(transaction.transactionSummary, min, max) ||
    IsTransactionCurrencyLimitValueOverflow(transaction.transactionCurrencySummary, min, max)
  ) {
    return true;
  }
  return false;
};

const IsTransactionSummaryLimitValueOverflow = (transactionSummary, min, max) => {
  const netAmount = transactionSummary.netAmount ? transactionSummary.netAmount.ToNumber() : 0;
  const zeroVatTotal = transactionSummary.zeroVatTotal ? transactionSummary.zeroVatTotal.ToNumber() : 0;
  const vatExemptedTotal = transactionSummary.vatExemptedTotal ? transactionSummary.vatExemptedTotal.ToNumber() : 0;
  const preVatTotal = transactionSummary.vat.preVatTotal ? transactionSummary.vat.preVatTotal.ToNumber() : 0;
  const vatTotal = transactionSummary.vat.vatTotal ? transactionSummary.vat.vatTotal.ToNumber() : 0;
  const subTotalForCalculateWht = transactionSummary.subTotalForCalculateWht
    ? transactionSummary.subTotalForCalculateWht.ToNumber()
    : 0;
  const whtTotal = transactionSummary.paymentWht.whtTotal ? transactionSummary.paymentWht.whtTotal.ToNumber() : 0;
  const discount = transactionSummary.discount ? transactionSummary.discount.ToNumber() : 0;

  if (
    min >= netAmount ||
    min >= zeroVatTotal ||
    min >= vatExemptedTotal ||
    min >= preVatTotal ||
    min >= vatTotal ||
    min >= subTotalForCalculateWht ||
    min >= whtTotal ||
    min >= discount
  ) {
    return true;
  } else if (
    max < netAmount ||
    max <= zeroVatTotal ||
    max <= vatExemptedTotal ||
    max <= preVatTotal ||
    max <= vatTotal ||
    max <= subTotalForCalculateWht ||
    max <= whtTotal ||
    max <= discount
  ) {
    return true;
  }
  return false;
};

const IsTransactionCurrencyLimitValueOverflow = (transactionCurrencySummary, min, max) => {
  const currencyNetAmount = transactionCurrencySummary.netAmount ? transactionCurrencySummary.netAmount.ToNumber() : 0;
  const currencyZeroVatTotal = transactionCurrencySummary.zeroVatTotal
    ? transactionCurrencySummary.zeroVatTotal.ToNumber()
    : 0;
  const currencyVatExemptedTotal = transactionCurrencySummary.vatExemptedTotal
    ? transactionCurrencySummary.vatExemptedTotal.ToNumber()
    : 0;
  const currencyPreVatTotal = transactionCurrencySummary.vat.preVatTotal
    ? transactionCurrencySummary.vat.preVatTotal.ToNumber()
    : 0;
  const currencyVatTotal = transactionCurrencySummary.vat.vatTotal
    ? transactionCurrencySummary.vat.vatTotal.ToNumber()
    : 0;
  const whtTotal = transactionCurrencySummary.whtTotal ? transactionCurrencySummary.whtTotal.ToNumber() : 0;
  const currencyExchangeRates = transactionCurrencySummary.exchangeRate
    ? transactionCurrencySummary.exchangeRate.ToNumber()
    : 0;

  if (
    min >= currencyNetAmount ||
    min >= currencyZeroVatTotal ||
    min >= currencyVatExemptedTotal ||
    min >= currencyPreVatTotal ||
    min >= currencyVatTotal ||
    min >= whtTotal ||
    min >= currencyExchangeRates
  ) {
    return true;
  } else if (
    max < currencyNetAmount ||
    max <= currencyZeroVatTotal ||
    max <= currencyVatExemptedTotal ||
    max <= currencyPreVatTotal ||
    max <= currencyVatTotal ||
    max <= whtTotal ||
    max <= currencyExchangeRates
  ) {
    return true;
  }
  return false;
};

const IsTransactionItemListLimitValueOverflow = (transactionItemList, min, max) => {
  const isTransactionItemListLimitValueOverflow = false;
  for (const transactionItem of transactionItemList) {
    const price = transactionItem.price.value ? transactionItem.price.value.ToNumber() : 0;
    const amount = transactionItem.amount.value ? transactionItem.amount.value.ToNumber() : 0;
    const discount = transactionItem.discount.value ? transactionItem.discount.value.ToNumber() : 0;
    const whtAmount = transactionItem.itemWht.value ? transactionItem.itemWht.value.ToNumber() : 0;
    const netAmount = transactionItem.itemNetTotal ? transactionItem.itemNetTotal.ToNumber() : 0;

    if (min >= price || min >= amount || min >= discount || min >= whtAmount || min >= netAmount) {
      isTransactionItemListLimitValueOverflow = true;
    } else if (max <= price || max <= amount || max <= discount || max <= whtAmount || max <= netAmount) {
      isTransactionItemListLimitValueOverflow = true;
    }

    if (isTransactionItemListLimitValueOverflow) {
      break;
    }
  }
  return isTransactionItemListLimitValueOverflow;
};

function TransactionValidationAndRemoveTransactionItemEmptyBase(
  transaction,
  triggerAlert = true,
  isImportTransaction = false,
  isBookmarkValidate = false
) {
  let numberValidateError = false;
  if (!isBookmarkValidate) {
    if (isImportTransaction) {
      numberValidateError = transaction.number.validateError;
    } else {
      numberValidateError = transaction.number.value === "" || transaction.number.validateError;
    }
  }
  let referenceValidateError = transaction.reference.validateError;
  let transactionListValidateError = false;
  let contactValidateError = false;
  let dateValidateError = !transaction.date.value || transaction.date.validateError;
  let dueDateValidateError = false;
  let allocationValidateError = false;
  let netAmountValidateError = transaction.transactionSummary.netAmount.ToNumber() < 0 ? true : false;
  let paymentValidateError = false;
  let remarkValidateError = transaction.remark.text ? transaction.remark.validateError : false;
  let purchaseTaxInvoiceValidateError = false;
  let transactionCurrencySummaryVatIsActive = false;
  let transactionCurrencySummaryValidateDepositError = false;
  let receivedTaxInvoiceValidateError = transaction.receivedTaxInvoice
    ? transaction.receivedTaxInvoice.validateError
    : false;
  let returnStockTypeValidateError = false;
  let reasonDescriptionValidateError = false;
  let reasonTypeValidateError = false;
  let billingNoteTransactionItemError = false;
  let transactionLimitValueOverflow = false;
  let transactionIsHaveVatError = false;

  if (
    transaction.transactionType == Enums.TransactionType.CreditNote ||
    transaction.transactionType == Enums.TransactionType.DebitNote
  ) {
    returnStockTypeValidateError = transaction.returnStock.validateError || transaction.returnStock.value.id == 0;
    reasonDescriptionValidateError =
      transaction.reasonDescription.validateError ||
      transaction.reasonDescription.text == null ||
      transaction.reasonDescription.text.trim() == "";
    reasonTypeValidateError = transaction.reasonType.value == null || transaction.reasonType.value.id == 0;
  }

  if (
    transaction.transactionType !== Enums.TransactionType.TaxInvoice &&
    !(
      transaction.transactionType === Enums.TransactionType.Receipt &&
      (transaction.reference.referenceTypeId === Enums.TransactionType.Invoice ||
        transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote)
    )
  ) {
    transactionListValidateError = transaction.isValidateError;
    if (!isBookmarkValidate) {
      if (transaction.transactionType !== Enums.TransactionType.PurchaseRequisition) {
        contactValidateError = transaction.contact.validateError || transaction.contact.id === 0;
      }
    }
    if (transaction.transactionCurrencySummary.vat) {
      transactionCurrencySummaryVatIsActive = transaction.transactionCurrencySummary.vat.isActive;
    }
  }
  if (
    !(
      transaction.transactionType === Enums.TransactionType.PurchaseRequisition ||
      transaction.transactionType === Enums.TransactionType.Quotation ||
      transaction.transactionType === Enums.TransactionType.GoodsReceipt ||
      transaction.transactionType === Enums.TransactionType.InvoiceReceipt ||
      transaction.transactionType === Enums.TransactionType.TaxInvoice
    ) ||
    (transaction.transactionType === Enums.TransactionType.Receipt &&
      (transaction.reference.referenceTypeId === Enums.TransactionType.Invoice ||
        transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote) &&
      transaction.reference.paymentGroupId !== 0)
  ) {
    paymentHelper.ValidationAllPaymentGroup(transaction, transaction.transactionType, transaction.financeType);
    paymentValidateError = transaction.payment ? transaction.payment.isValidateError : false;
  }

  if (
    transaction.transactionType === Enums.TransactionType.Invoice ||
    (transaction.transactionType === Enums.TransactionType.Quotation &&
      transaction.financeType === Enums.FinanceType.InFlow)
  ) {
    dueDateValidateError = !transaction.dueDate.value || transaction.dueDate.validateError;
  }

  if (transaction.transactionType === Enums.TransactionType.BillingNote) {
    billingNoteTransactionItemError = ValidateBillingTransactionItem(transaction.transactionItemList);
  }

  transactionCurrencySummaryValidateDepositError = ValidateTransactionCurrencySummaryDepositError(transaction);

  transactionLimitValueOverflow = ValidateTransactionLimitValueOverflow(transaction);

  if (!transaction.isBillingNoteTransaction && transaction.transactionType !== Enums.TransactionType.BillingNote) {
    transactionIsHaveVatError = ValidateTransactionIsHaveVatError(transaction);
    allocationValidateError = ValidateTransactionAllocationValidateError(transaction);
  }

  let returnTransactionValidateError = true;
  if (
    !numberValidateError &&
    !referenceValidateError &&
    !transactionListValidateError &&
    !contactValidateError &&
    !netAmountValidateError &&
    !paymentValidateError &&
    !purchaseTaxInvoiceValidateError &&
    !dateValidateError &&
    !dueDateValidateError &&
    !allocationValidateError &&
    !transactionCurrencySummaryVatIsActive &&
    !remarkValidateError &&
    !receivedTaxInvoiceValidateError &&
    !returnStockTypeValidateError &&
    !reasonDescriptionValidateError &&
    !reasonTypeValidateError &&
    !billingNoteTransactionItemError &&
    !transactionCurrencySummaryValidateDepositError &&
    !transactionLimitValueOverflow &&
    !transactionIsHaveVatError
  ) {
    returnTransactionValidateError = false;
  } else if (triggerAlert) {
    transaction.contact.validateError = contactValidateError;
    transaction.date.validateError = dateValidateError;
    transaction.number.validateError = numberValidateError;
    if (
      transaction.transactionType == Enums.TransactionType.CreditNote ||
      transaction.transactionType == Enums.TransactionType.DebitNote
    ) {
      transaction.returnStock.validateError = returnStockTypeValidateError;
      transaction.reasonType.validateError = reasonTypeValidateError;
      transaction.reasonDescription.validateError = reasonDescriptionValidateError;
    }

    if (transaction.transactionType !== Enums.TransactionType.BillingNote) {
      transaction.transactionItemList.forEach((transactionItem) => {
        if (transactionItem.description.text === "") {
          transactionItem.description.validateError = true;
        }
      });
    }
    if (transactionListValidateError) {
      let pageErrorList = GetPageErrorListfromTransaction(transaction);

      for (const pageError of pageErrorList) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Please_Fill_In_Valid_In_Page", {
            pageNo: pageError.page,
            itemList: pageError.sequenceNumberList.join(", "),
          }),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    }

    if (netAmountValidateError) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Sorry_It_Unable_Generate_File_Since_The_Total_Amount_Is_Not_An_Integer"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }

    let allocationItemIsHaveError = transaction.transactionItemList.find((x) => x.isAllocationItemError);

    if (allocationItemIsHaveError) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Please_Specify_Allocation_Again"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }

    if (allocationValidateError) {
      const validateAllocationTransactionLimitError = ValidateAllocationTransactionLimitByPackage(transaction);
      const validateAllocationTransactionItemLimitError = ValidateAllocationTransactionItemLimitByPackage(transaction);
      if (validateAllocationTransactionLimitError) {
        const maxAllocationCanInsert = GetMaxAllocationCanInsert();
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Package_Limit_Assigned_Classification_Group", { x: maxAllocationCanInsert }),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      } else if (validateAllocationTransactionItemLimitError) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Package_Limit_Assigned_Classification_TransactionItem"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    }

    if (billingNoteTransactionItemError) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Create_Failed_Because_Billing_Cannot_Zero_Or_Less"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }

    if (transactionCurrencySummaryValidateDepositError) {
      let alertMessage = "";
      const vatTotalNumber = transaction.transactionCurrencySummary.vat.vatTotal.ToNumber();
      const preVatTotalNumber = transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber();

      if (transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber() < 0) {
        if (transaction.financeType == Enums.FinanceType.InFlow) {
          alertMessage = i18n.t("Validate_Deposit_Alert.VAT_Exempted_Deposit_Receipt_Amount_More_Than");
        } else {
          if (transaction.expenseType == Enums.ExpenseType.PurchaseAsset) {
            alertMessage = i18n.t("Validate_Deposit_Alert.VAT_Exempted_Purchase_Asset_Amount_More_Than");
          } else {
            alertMessage = i18n.t("Validate_Deposit_Alert.VAT_Exempted_Deposit_Payment_Amount_More_Than");
          }
        }
      } else if (transaction.transactionCurrencySummary.zeroVatTotal.ToNumber() < 0) {
        if (transaction.financeType == Enums.FinanceType.InFlow) {
          alertMessage = i18n.t("Validate_Deposit_Alert.Zero_VAT_Deposit_Receipt_Amount_More_Than");
        } else {
          if (transaction.expenseType == Enums.ExpenseType.PurchaseAsset) {
            alertMessage = i18n.t("Validate_Deposit_Alert.Zero_VAT_Purchase_Asset_Amount_More_Than");
          } else {
            alertMessage = i18n.t("Validate_Deposit_Alert.Zero_VAT_Deposit_Payment_Amount_More_Than");
          }
        }
      } else if (preVatTotalNumber < 0) {
        if (transaction.financeType == Enums.FinanceType.InFlow) {
          alertMessage = i18n.t("Validate_Deposit_Alert.Pre_VAT_Deposit_Receipt_Amount_More_Than");
        } else {
          if (transaction.expenseType == Enums.ExpenseType.PurchaseAsset) {
            alertMessage = i18n.t("Validate_Deposit_Alert.Pre_VAT_Purchase_Asset_Amount_More_Than");
          } else {
            alertMessage = i18n.t("Validate_Deposit_Alert.Pre_VAT_Deposit_Payment_Amount_More_Than");
          }
        }
      } else if (vatTotalNumber < 0) {
        if (transaction.financeType == Enums.FinanceType.InFlow) {
          alertMessage = i18n.t("Validate_Deposit_Alert.VAT_Deposit_Receipt_Amount_More_Than");
        } else {
          if (transaction.expenseType == Enums.ExpenseType.PurchaseAsset) {
            alertMessage = i18n.t("Validate_Deposit_Alert.VAT_Purchase_Asset_Amount_More_Than");
          } else {
            alertMessage = i18n.t("Validate_Deposit_Alert.VAT_Deposit_Payment_Amount_More_Than");
          }
        }
      }
      store.dispatch("SetAlertMessage", {
        alertMessage: alertMessage,
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }

    if (transactionLimitValueOverflow) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("LimitTransactionValueOverFlow_Exception"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }
  }

  if (transactionIsHaveVatError) {
    store.dispatch("SetAlertMessage", {
      alertMessage: i18n.t("ErrorTransactionIsHaveVat_Exception"),
      typeMessage: Enums.TypeComponentNoti.error,
    });
  }

  if (!returnTransactionValidateError) {
    RemoveTransactionItemEmpty(transaction, triggerAlert);
  }

  return returnTransactionValidateError;
}
function RemoveTransactionItemEmpty(_transaction, triggerAlert) {
  if (
    triggerAlert &&
    _transaction.transactionType !== Enums.TransactionType.BillingNote &&
    _transaction.transactionItemList &&
    _transaction.transactionItemList.length > 1
  ) {
    let transactionItemList = _transaction.transactionItemList.filter((transactionItem) => {
      if (
        !(
          (!transactionItem.isDescriptionOnly &&
            transactionItem.account.id == 0 &&
            transactionItem.description.text == "" &&
            transactionItem.price.value.ToNumber() == 0 &&
            transactionItem.discount.value.ToNumber() == 0) ||
          (transactionItem.isDescriptionOnly && transactionItem.description.text == "")
        )
      ) {
        return transactionItem;
      }
    });

    if (transactionItemList && transactionItemList.length > 0) {
      _transaction.transactionItemList = transactionItemList;
    }
  }
}

function CheckErrorValueInput(_transaction, _isImport = false) {
  if (_transaction.transactionType != Enums.TransactionType.BillingNote) {
    _transaction.transactionItemList.forEach((transactionItem) => {
      TransactionItemValidation(transactionItem, _transaction, _isImport);
    });
    TransactionItemListValidate(_transaction, _isImport);
    SummaryValidation(_transaction);
  }
  switch (_transaction.transactionType) {
    case Enums.TransactionType.Receipt:
    case Enums.TransactionType.Invoice:
    case Enums.TransactionType.CreditNote:
    case Enums.TransactionType.DebitNote:
    case Enums.TransactionType.BillingNote:
    case Enums.TransactionType.Deposit:
    case Enums.TransactionType.InvoiceReceipt:
      PaymentValidation(_transaction, _isImport);
      break;
  }
}

function PaymentValidation(_transaction, _isImport) {
  let isPaymentActive =
    _transaction.payment.paymentGroupList.find((paymentGroup) => paymentGroup.isPaymentActive == true) === undefined
      ? false
      : true;
  if (_transaction.payment && isPaymentActive) {
    let paymentAllGroupTotal = _transaction.payment.paymentAllGroupTotal.ToNumber().ToAccountingRoundUpNumber();
    let netAmount = _transaction.transactionSummary.remainPaymentNetAmount.ToNumber().ToAccountingRoundUpNumber();

    let paymentAmountValidate = false;
    let netAmountBankAccountValidate = false;

    if (
      (_transaction.transactionType === Enums.TransactionType.Receipt &&
        _transaction.financeType === Enums.FinanceType.InFlow) ||
      (_transaction.transactionType === Enums.TransactionType.CreditNote && _transaction.reference.referenceId > 0) ||
      _transaction.transactionType === Enums.TransactionType.BillingNote
    ) {
      paymentAmountValidate = paymentAllGroupTotal !== netAmount;
    } else {
      paymentAmountValidate = paymentAllGroupTotal > netAmount;
    }
    let paymentGroupValidate =
      _transaction.payment.paymentGroupList.find((paymentGroup) => paymentGroup.validateError == true) === undefined
        ? false
        : true;

    let paymentGroupDateValidate = false;

    if (!_isImport) {
      paymentGroupDateValidate =
        _transaction.payment.paymentGroupList.find((paymentGroup) => !paymentGroup.paymentGroupDate) === undefined
          ? false
          : true;
    }

    _transaction.payment.isValidateError =
      paymentGroupValidate || paymentAmountValidate || paymentGroupDateValidate || netAmountBankAccountValidate;
  } else {
    _transaction.payment.isValidateError = false;
  }
}
function IsTransactionValidateTransactionItem(_transaction) {
  let isCanValidate = true;
  switch (_transaction.transactionType) {
    case Enums.TransactionType.Receipt:
      if (
        _transaction.reference.referenceTypeId === Enums.TransactionType.Invoice ||
        _transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote
      ) {
        isCanValidate = false;
      }
      break;
  }
  return isCanValidate;
}
function TransactionItemListValidate(_transaction, _isImport) {
  if (
    IsTransactionValidateTransactionItem(_transaction) &&
    _transaction.transactionItemList &&
    _transaction.transactionItemList.length > 0
  ) {
    let countTransactionItemEmpty = 0;
    let isValidateError = false;
    _transaction.transactionItemList.forEach((transactionItem) => {
      if (
        (!transactionItem.isDescriptionOnly &&
          transactionItem.productTemplate.id === 0 &&
          transactionItem.account.id === 0 &&
          transactionItem.description.text === "" &&
          transactionItem.price.value.ToNumber() === 0 &&
          transactionItem.discount.value.ToNumber() === 0) ||
        (transactionItem.isDescriptionOnly && transactionItem.description.text === "")
      ) {
        countTransactionItemEmpty += 1;
      } else if (transactionItem.isValidateError || transactionItem.description.text === "") {
        isValidateError = true;
      }
    });

    if (_transaction.transactionItemList.length === countTransactionItemEmpty) {
      _transaction.isValidateError = true;
    } else {
      _transaction.isValidateError = isValidateError;
    }

    if (_isImport) {
      if (_transaction.contact.id === 0) {
        _transaction.isValidateError = true;
      }
      if (
        _transaction.transactionType === Enums.TransactionType.Receipt &&
        (_transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountId === 0 ||
          _transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountId === "")
      ) {
        _transaction.isValidateError = true;
      }
    }
  }
}

function SummaryValidation(_transaction) {
  const transactionItemModel = GetTransactionItemList(_transaction);
  SetTransactionItemList(_transaction, transactionItemModel);

  const transactionSummaryModel = GetTransactionSummary(_transaction, transactionItemModel);

  let transactionDiscountValue = _transaction.transactionDiscount.value.ToNumber();

  if (transactionSummaryModel.transactionSummary.sameProductVatTypeId === Enums.ProductVatType.NotDefined) {
    _transaction.transactionDiscount.disabled = true;
  } else {
    _transaction.transactionDiscount.disabled = false;
    let transactionItemFindError = _transaction.transactionItemList.find(
      (transactionItem) => transactionItem.discount.validateError === true
    );
    let isTransactionItemDiscountError = transactionItemFindError === undefined ? false : true;
    if (!isTransactionItemDiscountError) {
      if (_transaction.transactionDiscount.discountType == Enums.DiscountType.Percent) {
        _transaction.transactionDiscount.validateError = transactionDiscountValue > 100;
      } else {
        _transaction.transactionDiscount.validateError =
          transactionSummaryModel.transactionCurrencySummary.netAmount.ToNumber() < 0 && transactionDiscountValue > 0;
      }

      if (transactionDiscountValue < 0) {
        _transaction.transactionDiscount.validateError = true;
      }
    }
  }
}

function ValidateTransactionItemPriceDefaultCase(transactionItem) {
  let validateError =
    transactionItem.price.value.ToNumber() > inputMaxNumber ||
    transactionItem.price.value.ToNumber() < inputMinNumber ||
    (transactionItem.price.value.ToNumber() < 0 &&
      transactionItem.productTemplate.id != 0 &&
      transactionItem.productTemplate.productTypeId === Enums.ProductType.Inventory);
  return validateError;
}

function ValidateTransactionItemAmountDefaultCase(transactionItem) {
  let validateError =
    transactionItem.amount.value.ToNumber() > inputMaxNumber || transactionItem.amount.value.ToNumber() < 0;
  return validateError;
}
function IsPurchaseOrderAsset(_transaction) {
  return (
    _transaction.transactionType == Enums.TransactionType.Quotation &&
    _transaction.financeType == Enums.FinanceType.OutFlow &&
    _transaction.transactionItemType == Enums.TransactionItemType.Asset
  );
}
function IsPurchaseAsset(_transaction) {
  return (
    _transaction.transactionType == Enums.TransactionType.Invoice &&
    _transaction.financeType == Enums.FinanceType.OutFlow &&
    _transaction.expenseType == Enums.ExpenseType.PurchaseAsset
  );
}
function TransactionItemValidation(transactionItem, _transaction, _isImport) {
  if (_transaction.isHumanChange) {
    transactionItem.description.validateError =
      transactionItem.description.text.toString().length > 1000 || transactionItem.description.text === "";

    if (!transactionItem.isDescriptionOnly) {
      if (IsPurchaseAsset(_transaction)) {
        transactionItem.fixedAssetTemplate.validateError =
          transactionItem.fixedAssetTemplate.id == 0 && !transactionItem.fixedAssetTemplate.isService;
      }

      if (
        _transaction.transactionType == Enums.TransactionType.Invoice &&
        _transaction.financeType == Enums.FinanceType.InFlow &&
        _transaction.expenseType == Enums.ExpenseType.PurchaseAsset
      ) {
        transactionItem.fixedAssetTemplate.validateError = transactionItem.fixedAssetTemplate.id == 0;
        if (!transactionItem.fixedAsset.disabled && transactionItem.fixedAssetTemplate.id > 0) {
          transactionItem.fixedAsset.validateError = transactionItem.fixedAsset.id == 0;
        } else {
          transactionItem.fixedAsset.validateError = false;
        }
      }

      if (
        _transaction.transactionType == Enums.TransactionType.TaxInvoice &&
        _transaction.financeType == Enums.FinanceType.InFlow &&
        _transaction.transactionItemType == Enums.TransactionItemType.Asset
      ) {
        transactionItem.fixedAssetTemplate.validateError = transactionItem.fixedAssetTemplate.id == 0;
        if (!transactionItem.fixedAsset.disabled && transactionItem.fixedAssetTemplate.id > 0) {
          transactionItem.fixedAsset.validateError = transactionItem.fixedAsset.id == 0;
        } else {
          transactionItem.fixedAsset.validateError = false;
        }
      }

      if (
        _transaction.transactionType == Enums.TransactionType.Receipt &&
        _transaction.financeType == Enums.FinanceType.InFlow &&
        _transaction.transactionItemType == Enums.TransactionItemType.Asset
      ) {
        transactionItem.fixedAssetTemplate.validateError = transactionItem.fixedAssetTemplate.id == 0;
        if (!transactionItem.fixedAsset.disabled && transactionItem.fixedAssetTemplate.id > 0) {
          transactionItem.fixedAsset.validateError = transactionItem.fixedAsset.id == 0;
        } else {
          transactionItem.fixedAsset.validateError = false;
        }
      }
    }
  }

  if (_transaction.transactionType == Enums.TransactionType.CreditNote && _transaction.reference.referenceId > 0) {
    transactionItem.amount.validateError =
      transactionItem.amount.value.ToNumber() > transactionItem.remainingAmount ||
      transactionItem.amount.value.ToNumber() < 0;
    if (!transactionItem.amount.validateError) {
      let transactionItemNetAmount = peakUtility
        .PeakOperatorMultiply(transactionItem.price.value.ToNumber(), transactionItem.amount.value.ToNumber())
        .ToAccountingRoundUpNumber();
      transactionItem.price.validateError =
        transactionItem.price.disabled || transactionItem.isDescriptionOnly
          ? false
          : transactionItemNetAmount > transactionItem.remainingNetAmount.ToAccountingRoundUpNumber() ||
            transactionItem.price.value.ToNumber() <= 0;
    }
  } else {
    transactionItem.amount.validateError = ValidateTransactionItemAmountDefaultCase(transactionItem);
    transactionItem.price.validateError = ValidateTransactionItemPriceDefaultCase(transactionItem);
  }

  if (transactionItem.productTemplate.id > 0 && !transactionItem.account.id) {
    transactionItem.account.validateError = true;
  } else {
    transactionItem.account.validateError = false;
  }

  transactionItem.itemWht.validateError =
    transactionItem.itemWht.value !== null &&
    transactionItem.itemPreVatTotal.ToNumber() > 0 &&
    transactionItem.itemWht.value.ToNumber() > transactionItem.itemPreVatTotal.ToNumber()
      ? true
      : false;

  DiscountValidation(transactionItem);

  const isPartialQuotationItemTypeTransactionItem =
    _transaction.reference.referenceTypeId == Enums.TransactionType.Quotation &&
    _transaction.reference.referenceId > 0 &&
    _transaction.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.TransactionItem &&
    transactionItem.checked.value === true &&
    transactionItem.referenceQuotationItemId > 0;

  if (isPartialQuotationItemTypeTransactionItem) {
    ValidatePartialQuotationItemTypeTransactionItem(
      transactionItem,
      _transaction.transactionType,
      _transaction.financeType,
      _transaction.transactionItemType,
      _transaction.expenseType,
      _transaction.settingQuotationPartial
    );
  }

  transactionItem.isAllocationItemError = false;
  if (!transactionItem.isUseTransactionAllocation) {
    if (transactionItem.account.id > 0) {
      if (
        transactionItem.itemNetAmountWithAllocateDiscountTotal.ToNumber() !==
        transactionItem.itemNetAmountWithAllocateDiscountForAllocation.ToNumber()
      ) {
        transactionItem.isAllocationItemError = true;
      }
    } else {
      transactionItem.isUseTransactionAllocation = true;
    }
  }

  if (
    !transactionItem.account.validateError &&
    !transactionItem.description.validateError &&
    !transactionItem.amount.validateError &&
    !transactionItem.price.validateError &&
    !transactionItem.discount.validateError &&
    !transactionItem.itemWht.validateError &&
    !transactionItem.fixedAssetTemplate.validateError &&
    !transactionItem.fixedAsset.validateError &&
    !transactionItem.isAllocationItemError
  ) {
    transactionItem.isValidateError = false;
  } else {
    transactionItem.isValidateError = true;
  }

  if (_transaction.taxStatus.value == Enums.TaxTypeId.None) {
    transactionItem.vatTypeId.disabled = true;
  } else {
    transactionItem.vatTypeId.disabled = false;
  }
}

function SetCreateAllocationTransaction(allocationList, maxAllocationShow) {
  let count = 0;
  let allocationTransactionList = [];
  if (allocationList && allocationList.length > 0) {
    for (let allocation of allocationList) {
      if (!allocation.isArchived && count < maxAllocationShow) {
        let allocationTransaction = {
          allocationId: allocation.allocationId,
          allocationItemList: [],
          allocation: allocation,
          isSetDefaultValue: false,
        };
        allocationTransactionList.push(allocationTransaction);
        count++;
      }
    }
  }
  return allocationTransactionList;
}
function SetEditAllocationTransaction(allocationTransactionRawList, allocationList, financeType) {
  let allocationTransactionList = [];
  if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
    for (let allocationTransactionRaw of allocationTransactionRawList) {
      if (
        allocationTransactionRaw.allocationId &&
        allocationTransactionRaw.allocationItemList &&
        allocationTransactionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransactionRaw.allocationId,
          allocationItemList: [],
          allocation: allocationList.find((x) => x.id == allocationTransactionRaw.allocationId),
          isSetDefaultValue: true,
        };

        for (let allocationItemRaw of allocationTransactionRaw.allocationItemList) {
          if (allocationItemRaw.allocationItemId > 0) {
            allocationTransaction.allocationItemList.push({
              id: allocationItemRaw.allocationItemId,
              percent: allocationItemRaw.allocationPercent.ToNumber() + "%",
              valueType: allocationItemRaw.allocationValueType,
              amount: allocationItemRaw.allocationValue,
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  const maxAllocationShow = GetMaxAllocationShowByPackage();
  let count = 0;
  if (allocationList && allocationList.length > 0) {
    for (let allocation of allocationList) {
      let selectedAllocationTransaction = null;
      if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
        selectedAllocationTransaction = allocationTransactionRawList.find((x) => x.allocationId == allocation.id);
      }
      if (!allocation.isArchived && count < maxAllocationShow && !selectedAllocationTransaction) {
        let canAddToArray = false;
        if (financeType === Enums.FinanceType.InFlow) {
          canAddToArray =
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Income ||
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All;
        } else if (financeType == Enums.FinanceType.OutFlow) {
          canAddToArray =
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Expense ||
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All;
        } else if (financeType === Enums.FinanceType.None) {
          canAddToArray = true;
        }
        if (canAddToArray) {
          let allocationTransaction = {
            allocationId: allocation.id,
            allocationItemList: [],
            allocation: allocation,
            isSetDefaultValue: false,
          };
          allocationTransactionList.push(allocationTransaction);
          count++;
        }
      } else if (selectedAllocationTransaction && !allocation.isArchived) {
        count++;
      }
    }
  }
  return allocationTransactionList;
}
function SetEditAllocationJournal(allocationTransactionRawList, allocationList) {
  let allocationTransactionList = [];
  if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
    for (let allocationTransactionRaw of allocationTransactionRawList) {
      if (
        allocationTransactionRaw.allocationId &&
        allocationTransactionRaw.allocationItemList &&
        allocationTransactionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransactionRaw.allocationId,
          allocationItemList: [],
          allocation: allocationList.find((x) => x.id == allocationTransactionRaw.allocationId),
          isSetDefaultValue: true,
        };

        for (let allocationItemRaw of allocationTransactionRaw.allocationItemList) {
          if (allocationItemRaw.allocationItemId > 0) {
            const isDebit = allocationItemRaw.allocationDebit != 0;
            allocationTransaction.allocationItemList.push({
              id: allocationItemRaw.allocationItemId,
              percent: allocationItemRaw.allocationPercent.ToNumber() + "%",
              valueType: allocationItemRaw.allocationValueType,
              amount: isDebit ? allocationItemRaw.allocationDebit : allocationItemRaw.allocationCredit,
              isDebit: isDebit,
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  const maxAllocationShow = GetMaxAllocationShowByPackage(true);
  let count = 0;
  if (allocationList && allocationList.length > 0) {
    for (let allocation of allocationList) {
      let selectedAllocationTransaction = null;
      if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
        selectedAllocationTransaction = allocationTransactionRawList.find((x) => x.allocationId == allocation.id);
      }
      if (!allocation.isArchived && count < maxAllocationShow && !selectedAllocationTransaction) {
        let allocationTransaction = {
          allocationId: allocation.id,
          allocationItemList: [],
          allocation: allocation,
          isSetDefaultValue: false,
        };
        allocationTransactionList.push(allocationTransaction);
        count++;
      } else if (selectedAllocationTransaction && !allocation.isArchived) {
        count++;
      }
    }
  }
  return allocationTransactionList;
}
function DiscountValidation(transactionItem) {
  let price = transactionItem.price.value.ToNumber();
  let discount = transactionItem.discount.value.ToNumber();
  if (price >= 0) {
    if (transactionItem.discount.discountTypeId == Enums.DiscountType.Currency) {
      transactionItem.discount.validateError = discount > price ? true : false;
    } else if (transactionItem.discount.discountTypeId == Enums.DiscountType.Percent) {
      transactionItem.discount.validateError = discount > 100 ? true : false;
    }
  } else {
    transactionItem.discount.value = "0.00";
    transactionItem.discount.validateError = false;
  }
}
function GetCreateTransactionItemFromTransactionItem(
  transactionDetailItem,
  transactionType = Enums.TransactionType.None,
  financeType = Enums.FinanceType.None,
  isCanEdit = true,
  expenseType = Enums.ExpenseType.None,
  transactionItemType = Enums.TransactionItemType.None
) {
  let transactionItem = GetCreateTransactionItemDefualt(transactionType, financeType, expenseType, transactionItemType);
  transactionItem.referencePrice = transactionDetailItem.price.ToPeakTransactionItemFormat();
  transactionItem.referenceAmount = transactionDetailItem.amount.ToPeakTransactionItemFormat();
  transactionItem.referenceDescription = transactionDetailItem.description;
  transactionItem.referenceDiscount = transactionDetailItem.discount.ToPeakTransactionItemFormat();
  transactionItem.referenceDiscountType = transactionDetailItem.discountType;
  transactionItem.referenceStockActivityId = transactionDetailItem.referenceStockActivityId;
  transactionItem.isDescriptionOnly = transactionDetailItem.isDescriptionOnly;
  transactionItem.productTemplate.id = transactionDetailItem.productTemplateId;
  transactionItem.referenceProductTemplateId = transactionDetailItem.productTemplateId;
  transactionItem.productTemplate.code = transactionDetailItem.productTemplateCode;
  transactionItem.productTemplate.disabled = !isCanEdit;
  transactionItem.productTemplate.standardPrice = 0;
  transactionItem.fixedAssetTemplate.id = transactionDetailItem.assetTemplateId;
  transactionItem.referenceFixedAssetTemplateId = transactionDetailItem.assetTemplateId;
  transactionItem.fixedAssetTemplate.code = transactionDetailItem.fixAssetTemplateCode;
  transactionItem.fixedAssetTemplate.disabled = !isCanEdit;
  transactionItem.fixedAssetTemplate.isNotAuto = true;
  if (expenseType == Enums.ExpenseType.PurchaseAsset || transactionItemType == Enums.ExpenseType.PurchaseAsset) {
    transactionItem.fixedAssetTemplate.isService = transactionDetailItem.isAcquisitionCost;
  }
  transactionItem.fixedAsset.id = transactionDetailItem.assetId;
  transactionItem.fixedAsset.disabled = !isCanEdit;
  transactionItem.fixedAsset.isNotAuto = true;
  if (transactionItem.productTemplate.id > 0) {
    transactionItem.productTemplate.isNotAuto = true;
  }

  if (transactionType !== Enums.TransactionType.Deposit) {
    transactionItem.referenceAccountId = transactionDetailItem.accountId;
    transactionItem.account.id = transactionDetailItem.accountId;
    transactionItem.account.code = transactionDetailItem.accountCode;
  }

  if (transactionItem.account.id > 0 || transactionItem.productTemplate.isNotAuto) {
    transactionItem.account.isNotAuto = true;
  }
  if (expenseType == Enums.ExpenseType.PurchaseAsset || transactionItemType == Enums.ExpenseType.PurchaseAsset) {
    transactionItem.account.disabled = transactionItem.account.disabled ? true : !isCanEdit;
  } else {
    transactionItem.account.disabled = transactionItem.account.disabled ? true : !isCanEdit;
  }
  transactionItem.description.text = transactionDetailItem.description;
  transactionItem.description.disabled = !isCanEdit;
  transactionItem.amount.value = transactionDetailItem.amount.ToPeakTransactionItemFormat();
  transactionItem.amount.disabled = !isCanEdit;
  transactionItem.price.value = transactionDetailItem.price.ToPeakTransactionItemFormat();
  transactionItem.price.disabled = !isCanEdit;
  transactionItem.discount.value = transactionDetailItem.discount.ToPeakTransactionItemFormat();
  transactionItem.discount.discountTypeId = transactionDetailItem.discountType;
  transactionItem.discount.disabled = !isCanEdit;
  transactionItem.vatTypeId.value = transactionDetailItem.vatType;
  transactionItem.vatTypeId.disabled = !isCanEdit;
  transactionItem.itemWht.value = transactionDetailItem.whtAmount;
  transactionItem.itemWht.whtAmountType = transactionDetailItem.whtAmountType;
  transactionItem.itemWht.disabled = !isCanEdit;
  if (transactionItem.itemWht.whtAmountType !== 0) {
    transactionItem.itemWht.isNotAuto = true;
  }
  transactionItem.itemNetAmountWithAllocateDiscountTotal = transactionDetailItem.itemNetAmountWithAllocateDiscountTotal;
  transactionItem.itemNetAmountWithAllocateDiscountForAllocation =
    transactionDetailItem.itemNetAmountWithAllocateDiscountForAllocation;
  transactionItem.remainingNetAmount = transactionDetailItem.remainingNetAmount;
  transactionItem.remainingAmount = transactionDetailItem.remainingAmount;
  return transactionItem;
}
function GetCreateTransactionItemForAIChartOfAccount(
  chartOfAccountId,
  transactionType,
  financeType,
  expenseType = Enums.ExpenseType.None,
  transactionItemType = Enums.TransactionItemType.None
) {
  let transactionItem = GetCreateTransactionItemDefualt(transactionType, financeType, expenseType, transactionItemType);
  transactionItem.account.id = chartOfAccountId;
  transactionItem.account.isNotAuto = false;
  return transactionItem;
}
function GetCreateTransactionItemDefualt(
  transactionType,
  financeType,
  expenseType = Enums.ExpenseType.None,
  transactionItemType = Enums.TransactionItemType.None
) {
  let hiddenProduct = false;
  let hiddenAssetTemplate = false;
  let hiddenAccount = false;
  let hiddenAsset = false;
  let hiddenAmount = false;
  let hiddenDiscount = false;
  let disabledAccount = false;
  let defaultAccountId = 0;

  switch (transactionType) {
    case Enums.TransactionType.PurchaseRequisition:
      hiddenAssetTemplate = true;
      hiddenAsset = true;
      break;
    case Enums.TransactionType.Quotation:
      if (expenseType == Enums.TransactionItemType.Asset || transactionItemType == Enums.TransactionItemType.Asset) {
        hiddenProduct = true;
        hiddenAsset = true;
        disabledAccount = true;
      } else {
        hiddenAssetTemplate = true;
        hiddenAsset = true;
      }
      break;
    case Enums.TransactionType.Deposit:
      hiddenAssetTemplate = true;
      hiddenAsset = true;
      disabledAccount = true;
      hiddenDiscount = true;
      if (financeType == Enums.FinanceType.InFlow) {
        defaultAccountId = 235; //212104 - เงินรับล่วงหน้า - เงินมัดจำ
      } else {
        defaultAccountId = 232; //115104 - เงินจ่ายล่วงหน้า - เงินมัดจำ
      }
      break;
    case Enums.TransactionType.GoodsReceipt:
    case Enums.TransactionType.InvoiceReceipt:
      hiddenAssetTemplate = true;
      hiddenAsset = true;
      break;
    case Enums.TransactionType.Invoice:
    case Enums.TransactionType.Receipt:
      if (financeType == Enums.FinanceType.InFlow) {
        if (expenseType == Enums.ExpenseType.PurchaseAsset || transactionItemType == Enums.TransactionItemType.Asset) {
          hiddenProduct = true;
          hiddenAccount = true;
          hiddenAmount = true;
        } else {
          hiddenAssetTemplate = true;
          hiddenAsset = true;
        }
      } else if (financeType == Enums.FinanceType.OutFlow) {
        if (expenseType == Enums.ExpenseType.Expense) {
          hiddenProduct = true;
          hiddenAssetTemplate = true;
          hiddenAsset = true;
        } else if (
          expenseType == Enums.ExpenseType.PurchaseInventory ||
          transactionItemType == Enums.TransactionItemType.Inventory
        ) {
          hiddenAssetTemplate = true;
          hiddenAsset = true;
        } else if (
          expenseType == Enums.ExpenseType.PurchaseAsset ||
          transactionItemType == Enums.TransactionItemType.Asset
        ) {
          hiddenProduct = true;
          hiddenAsset = true;
          disabledAccount = true;
        }
      }
      break;
    case Enums.TransactionType.TaxInvoice:
      if (financeType == Enums.FinanceType.InFlow) {
        if (expenseType == Enums.ExpenseType.PurchaseAsset || transactionItemType == Enums.TransactionItemType.Asset) {
          hiddenProduct = true;
          hiddenAccount = true;
          hiddenAmount = true;
        } else {
          hiddenAssetTemplate = true;
          hiddenAsset = true;
        }
      }
      break;
    case Enums.TransactionType.DebitNote:
      hiddenAssetTemplate = true;
      hiddenAsset = true;
      break;
    case Enums.TransactionType.CreditNote:
      hiddenAssetTemplate = true;
      hiddenAsset = true;
      break;
  }

  return {
    isImportEnableEdit: false,
    isDescriptionOnly: false,
    isValidateError: false,
    alertMessage: "",
    referencePrice: 0,
    referenceAmount: 0,
    referenceDescription: "",
    referenceDiscount: 0,
    referenceDiscountType: Enums.DiscountType.Currency,
    referenceStockActivityId: 0,
    referenceQuotationItemId: 0,
    hidden: false,
    checked: {
      value: true,
      hidden: true,
    },
    productTemplate: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenProduct,
      productTypeId: 2,
      isNotAuto: false,
      validateError: false,
    },
    fixedAssetTemplate: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenAssetTemplate,
      scarpAmount: 0,
      isNotAuto: false,
      validateError: false,
      isService: false,
    },
    fixedAsset: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenAsset,
      isNotAuto: false,
      validateError: false,
    },
    account: {
      id: defaultAccountId,
      code: "",
      name: "",
      hidden: hiddenAccount,
      taxIncomeTypeId: 0,
      disabled: disabledAccount,
      isNotAuto: false,
      validateError: false,
    },
    description: {
      text: "",
      disabled: false,
      validateError: false,
    },
    unit: {
      id: 0,
      name: "",
      disabled: false,
    },
    amount: {
      value: "1.00",
      disabled: false,
      validateError: false,
      hidden: hiddenAmount,
    },
    price: {
      value: "0.00",
      disabled: false,
      validateError: false,
    },
    discount: {
      value: "0.00",
      disabled: false,
      discountTypeId: 0,
      validateError: false,
      hidden: hiddenDiscount,
    },
    vatTypeId: {
      value: 3,
      disabled: false,
      isSuggestion: false,
      validateError: false,
    },
    itemPreVatTotal: "0.00",
    itemVatTotal: "0.00",
    itemNetTotal: "0.00",
    itemWht: {
      text: "",
      value: null,
      percent: 0,
      whtAmountType: -2,
      disabled: false,
      validateError: false,
      isNotAuto: false,
    },
    isUseTransactionAllocation: true,
    itemNetAmountWithAllocateDiscountForAllocation: 0,
    itemNetAmountWithAllocateDiscountTotal: 0,
    isAllocationItemError: false,
    allocationTransactionList: [],
    remainStock: {
      value: 0,
      isProduct: false,
      lastestDate: null,
    },
    fromCurrencyPrice: 0,
    fromCurrencyDiscount: 0,
    fromCurrencyWHTTotal: 0,
    fromCurrencyNetTotal: 0,
    fromCurrencyVatTotal: 0,
    fromCurrencyPreVatTotal: 0,
    fromCurrencyZeroVatTotal: 0,
    fromCurrencyVatExemptedTotal: 0,
    fromCurrencySubTotalForcalculateWHT: 0,
    toCurrencyPrice: 0,
    toCurrencyDiscount: 0,
    toCurrencyWHTTotal: 0,
    toCurrencyNetTotal: 0,
    toCurrencyVatTotal: 0,
    toCurrencyPreVatTotal: 0,
    toCurrencyZeroVatTotal: 0,
    toCurrencyVatExemptedTotal: 0,
    toCurrencySubTotalForcalculateWHT: 0,
  };
}
function GetCreateTransactionSummaryDefualt(isEditVatDisabled = false) {
  return {
    vatExemptedTotal: "0.00",
    zeroVatTotal: "0.00",
    vat: {
      preVatTotalDefualt: "0.00",
      preVatTotal: "0.00",
      vatTotalDefualt: "0.00",
      vatTotal: "0.00",
      disabled: isEditVatDisabled,
      isActive: false,
      vatTotalBeforeEdit: "0.00",
    },
    netAmount: "0.00",
    paymentWht: {
      whtTotal: 0,
      paymentNetAmount: 0,
      isShow: false,
    },
    subTotalForCalculateWht: 0,
    isNoneOrNotSpecifyWht: Enums.WhtAmountType.NotSpecify.value,
    remainPaymentNetAmount: 0,
    remainWhtPaymentNetAmount: 0,
    sameProductVatType: 0,
    isServiceOnly: false,
    sameProductVatTypeIdTransactionItemTypeProduct: 0,
    discount: 0,
  };
}
function GetCreateTransactionCurrencySummaryDefualt(isEditVatDisabled = false, disableCurrency = false) {
  return {
    vatExemptedTotal: "0.00",
    zeroVatTotal: "0.00",
    vat: {
      preVatTotalDefualt: "0.00",
      preVatTotal: "0.00",
      vatTotalDefualt: "0.00",
      vatTotal: "0.00",
      disabled: isEditVatDisabled,
      isActive: false,
      vatTotalBeforeEdit: "0.00",
    },
    netAmount: "0.00",
    fromCurrencyUId: 0,
    toCurrencyUId: 0,
    disabled: isEditVatDisabled,
    hidden: isEditVatDisabled,
    exchangeRate: 1,
    currencyCode: "THB",
    ratio: 1,
    hiddenExchangeRate: true,
    disableCurrency: disableCurrency,
    isGetSuggestionCurrency: false,
    whtTotal: 0,
    amountBeforeDiscount: "0.00",
    amountAfterDiscount: "0.00",
    referenceDepositTotal: "0.00",
    discount: 0,
  };
}
function CalculatePreVatTotalFromEditVatTransaction(transaction) {
  transaction.transactionCurrencySummary.vat.preVatTotal = (
    transaction.transactionCurrencySummary.vat.preVatTotalDefualt.ToNumber() +
    (transaction.transactionCurrencySummary.vat.vatTotalDefualt.ToNumber() -
      transaction.transactionCurrencySummary.vat.vatTotal.ToNumber())
  ).FormatMoney();
  let currencyRatio = transaction.transactionCurrencySummary.ratio;
  let currencyExchangeRates = transaction.transactionCurrencySummary.exchangeRate;
  transaction.transactionSummary.vat.vatTotal = CalculateWithCurrencyUid(
    transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
    currencyExchangeRates,
    currencyRatio,
    transaction.transactionCurrencySummary.toCurrencyUId
  ).FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = CalculateWithCurrencyUid(
    transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
    currencyExchangeRates,
    currencyRatio,
    transaction.transactionCurrencySummary.toCurrencyUId
  ).FormatMoney();
}

export const GetIsNoneOrNotSpecifyWhtTransactionItemList = (transaction) => {
  if (
    transaction &&
    transaction.transactionType !== Enums.TransactionType.BillingNote &&
    transaction.transactionItemList &&
    transaction.transactionItemList.length > 0
  ) {
    const isOnlyNoneOrNotSpecifyWht =
      transaction.transactionItemList.filter(
        (transactionItem) => transactionItem.itemWht.value > 0 || transactionItem.itemWht.value < 0
      ).length > 0
        ? false
        : true;
    const isHaveSomeNotSpecifyWht =
      transaction.transactionItemList.filter(
        (transactionItem) => transactionItem.itemWht.whtAmountType === Enums.WhtAmountType.NotSpecify.type
      ).length > 0;
    return isHaveSomeNotSpecifyWht && isOnlyNoneOrNotSpecifyWht;
  } else {
    return false;
  }
};

export const GetTransactionItemList = (_transaction) => {
  let transactionItemList = [];
  let total = 0;
  let sameProductVatTypeId = 0;
  let sameProductVatTypeIdTransactionItemTypeProduct = 0;
  let isServiceOnly = false;
  let totalForCalculateTransactionDiscount = 0;
  if (_transaction.transactionItemList.length > 0) {
    let isHaveProductTemplate = false;
    let isHaveProductTemplateTypeProduct = false;
    let transactionItemVatTypeIdSet = new Set();
    let defaultTransactionItemVatTypeId = Enums.ProductVatType.None;
    let dummyTransactionItemProductVatTypeId = 0;
    let countTransactionItemTypeProductWithoutDescriptionOnly = 0;
    let transactionListForCalculateAllocateDiscountPercent = ConvertTransactionListForCalculateAllocateDiscountPercent(
      _transaction.transactionItemList
    );
    let allocateDiscountPercent = CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      _transaction.transactionDiscount.value,
      _transaction.transactionDiscount.discountType,
      _transaction.taxStatus.value
    );

    const currencyExchangeRates = _transaction.transactionCurrencySummary.exchangeRate;
    const currencyRatio = _transaction.transactionCurrencySummary.ratio;
    const currencyUId = _transaction.transactionCurrencySummary.toCurrencyUId;

    const isNoneOrNotSpecifyWht = GetIsNoneOrNotSpecifyWhtTransactionItemList(_transaction);

    for (let sequenceNumber = 0; sequenceNumber < _transaction.transactionItemList.length; sequenceNumber++) {
      let _transactionItem = _transaction.transactionItemList[sequenceNumber];
      let isDescriptionOnly = _transactionItem.isDescriptionOnly;
      let accountId = 0;
      let transactionItemPrice = 0;
      let transactionItemAmount = 0;
      let transactionItemDiscount = 0;
      let transactionItemDiscountTypeId = 0;
      let transactionItemVatTypeId = 0;
      let transactionItemWhtAmountTypeId = -2;
      let transactionItemWhtAmount = 0;
      let productTemplateId = 0;
      let transactionItemDescription = _transactionItem.description;
      let fixedAssetTemplateId = 0;
      let transactionItemTotal = 0;
      let transactionItemTypeId = 0;
      let taxIncomeTypeId = 0;
      let transactionItemPreVatAmount = 0;
      let transactionItemVatAmount = 0;
      let discountValue = 0;
      let isAcquisitionCost = false;
      let itemWhtPercent = 0;
      let itemNetTotal = 0;
      let transactionItemForCalculateProductTotalPrice =
        ConvertTransactionItemForCalculateProductTotalPrice(_transactionItem);
      let netAmountWithAllocateDiscount = CalculateProductTotalPrice(
        transactionItemForCalculateProductTotalPrice,
        allocateDiscountPercent,
        _transaction.transactionCurrencySummary.toCurrencyUId,
        _transaction.transactionCurrencySummary.exchangeRate,
        _transaction.transactionCurrencySummary.ratio,
        _transaction.taxStatus.value,
        _transaction.issueTaxInvoice.value,
        _transaction.transactionType,
        _transaction.financeType,
        false
      );

      if (!isDescriptionOnly) {
        if (_transaction.transactionType != Enums.TransactionType.BillingNote) {
          if (
            !(
              _transaction.financeType === Enums.FinanceType.InFlow &&
              (_transaction.transactionType === Enums.TransactionType.Invoice ||
                _transaction.transactionType === Enums.TransactionType.Receipt) &&
              _transaction.transactionItemType == Enums.TransactionItemType.Asset
            )
          ) {
            accountId = _transactionItem.account.id.ToNumber();
            taxIncomeTypeId = _transactionItem.account.taxIncomeTypeId.ToNumber();
          }

          transactionItemPrice = _transactionItem.price.value.ToNumber();
          transactionItemAmount = _transactionItem.amount.value.ToNumber();

          discountValue = _transactionItem.discount.value;
          if (_transactionItem.discount.discountTypeId == 1) {
            transactionItemDiscount = discountValue.ToNumber();
            transactionItemDiscountTypeId = 1;
          } else {
            transactionItemDiscount = discountValue.ToNumber();
            transactionItemDiscountTypeId = 0;
          }
          transactionItemVatTypeId = _transactionItem.vatTypeId.value;
          productTemplateId = _transactionItem.productTemplate.id;
          fixedAssetTemplateId = _transactionItem.fixedAssetTemplate.id;
          isAcquisitionCost = _transactionItem.fixedAssetTemplate.isService;
          transactionItemWhtAmountTypeId = _transactionItem.itemWht.whtAmountType;
          itemWhtPercent = GetTransactionItemWhtPercent(transactionItemWhtAmountTypeId);

          if (_transactionItem.checked.value) {
            defaultTransactionItemVatTypeId = transactionItemVatTypeId;
            transactionItemVatTypeIdSet.add(transactionItemVatTypeId);
          }
        }

        if (_transaction.taxStatus.value == Enums.TaxTypeId.None) {
          transactionItemVatTypeId = Enums.ProductVatType.None;
        }

        if (productTemplateId > 0) {
          transactionItemTypeId = _transactionItem.productTemplate.productTypeId;
        } else if (fixedAssetTemplateId > 0) {
          transactionItemTypeId = _transactionItem.fixedAssetTemplate.fixedAssetTypeId;
        }
        if (productTemplateId > 0 || fixedAssetTemplateId > 0) {
          isHaveProductTemplate = true;
          if (transactionItemTypeId == Enums.ProductTemplateType.Product) {
            countTransactionItemTypeProductWithoutDescriptionOnly++;
            isHaveProductTemplateTypeProduct = true;
            if (countTransactionItemTypeProductWithoutDescriptionOnly === 1) {
              dummyTransactionItemProductVatTypeId = transactionItemVatTypeId;
              sameProductVatTypeIdTransactionItemTypeProduct = transactionItemVatTypeId;
            }

            if (dummyTransactionItemProductVatTypeId !== transactionItemVatTypeId) {
              sameProductVatTypeIdTransactionItemTypeProduct = 0;
            }
          }

          if (transactionItemTypeId == Enums.ProductTemplateType.Service && !isHaveProductTemplateTypeProduct) {
            isServiceOnly = true;
          } else {
            isServiceOnly = false;
          }
        }

        if (accountId > 0 && !isHaveProductTemplate) {
          isServiceOnly = true;
        }

        let transactionItemPriceTotal = 0;

        if (transactionItemDiscountTypeId === 1) {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(
            transactionItemPrice,
            peakUtility.PeakOperatorDivide(
              peakUtility.PeakOperatorMultiply(transactionItemPrice, transactionItemDiscount),
              100
            )
          );
        } else {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
        }
        transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);
        total = peakUtility.PeakOperatorAdd(total, transactionItemTotal);
        totalForCalculateTransactionDiscount = peakUtility.PeakOperatorAdd(
          totalForCalculateTransactionDiscount,
          transactionItemTotal > 0 ? transactionItemTotal : 0
        );
        if (_transaction.taxStatus.value === Enums.TaxTypeId.IncludeTax) {
          if (transactionItemVatTypeId === Enums.ProductVatType.SevenPercent) {
            transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
              peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
              100
            );
            transactionItemVatAmount = peakUtility.PeakOperatorSubtract(
              transactionItemTotal,
              transactionItemPreVatAmount
            );
          } else {
            transactionItemPreVatAmount = transactionItemTotal;
          }
        } else {
          transactionItemPreVatAmount = transactionItemTotal;
          if (
            _transaction.transactionType != Enums.TransactionType.BillingNote &&
            transactionItemVatTypeId === Enums.ProductVatType.SevenPercent
          ) {
            transactionItemVatAmount = peakUtility.PeakOperatorMultiply(
              transactionItemTotal,
              peakUtility.PeakOperatorDivide(7, 100)
            );
          }
        }
        if (transactionItemWhtAmountTypeId === Enums.WhtAmountType.NotSpecify.type) {
          transactionItemWhtAmount = null;
        } else if (transactionItemWhtAmountTypeId === Enums.WhtAmountType.None.type) {
          transactionItemWhtAmount = 0;
        } else if (transactionItemWhtAmountTypeId === Enums.WhtAmountType.Custom.type) {
          transactionItemWhtAmount = _transactionItem.itemWht.value ? _transactionItem.itemWht.value.ToNumber() : 0;
        } else {
          transactionItemWhtAmount = peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemPreVatAmount, itemWhtPercent),
            100
          );
        }

        itemNetTotal = peakUtility.PeakOperatorAdd(transactionItemPreVatAmount, transactionItemVatAmount).FormatMoney();
      }

      let toCurrencyVatTotal = 0;
      let toCurrencyPreVatTotal = 0;
      let toCurrencyZeroVatTotal = 0;
      let toCurrencyVatExemptedTotal = 0;
      let toCurrencySubTotalForcalculateWHT = 0;

      switch (transactionItemVatTypeId) {
        case Enums.ProductVatType.SevenPercent:
          toCurrencyVatTotal = transactionItemVatAmount;
          toCurrencyPreVatTotal = transactionItemPreVatAmount;

          break;
        case Enums.ProductVatType.ZeroPercent:
          toCurrencyZeroVatTotal = transactionItemTotal;

          break;
        case Enums.ProductVatType.None:
          toCurrencyVatExemptedTotal = transactionItemTotal;

          break;
      }

      const subTotalTransactionItemForcalculateWHT =
        toCurrencyPreVatTotal + toCurrencyZeroVatTotal + toCurrencyVatExemptedTotal;
      if (isNoneOrNotSpecifyWht && transactionItemWhtAmountTypeId === Enums.WhtAmountType.NotSpecify.type) {
        toCurrencySubTotalForcalculateWHT = subTotalTransactionItemForcalculateWHT;
      } else if (!isNoneOrNotSpecifyWht && (transactionItemWhtAmount > 0 || transactionItemWhtAmount < 0)) {
        toCurrencySubTotalForcalculateWHT = subTotalTransactionItemForcalculateWHT;
      }

      const toCurrencyNetTotal = subTotalTransactionItemForcalculateWHT + toCurrencyVatTotal;

      const fromCurrencyPrice = CalculateWithCurrencyUid(
        transactionItemPrice,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencyDiscount = CalculateWithCurrencyUid(
        transactionItemDiscount,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencyWHTTotal = CalculateWithCurrencyUid(
        transactionItemWhtAmount ? transactionItemWhtAmount : 0,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencyNetTotal = CalculateWithCurrencyUid(
        toCurrencyNetTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencyVatTotal = CalculateWithCurrencyUid(
        toCurrencyVatTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencyPreVatTotal = CalculateWithCurrencyUid(
        toCurrencyPreVatTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencyZeroVatTotal = CalculateWithCurrencyUid(
        toCurrencyZeroVatTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencyVatExemptedTotal = CalculateWithCurrencyUid(
        toCurrencyVatExemptedTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const fromCurrencySubTotalForcalculateWHT = CalculateWithCurrencyUid(
        toCurrencySubTotalForcalculateWHT,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();
      let transactionItem = {
        transactionItemTotal: transactionItemTotal,
        price: transactionItemPrice,
        amount: transactionItemAmount,
        accountid: accountId,
        discount: transactionItemDiscount,
        discountType: transactionItemDiscountTypeId,
        vatTypeId: transactionItemVatTypeId,
        whtAmountTypeId: transactionItemWhtAmountTypeId,
        whtAmount: transactionItemWhtAmount,
        productTemplateId: productTemplateId,
        fixAssetTemplateId: fixedAssetTemplateId,
        isAcquisitionCost: isAcquisitionCost,
        description: transactionItemDescription,
        sequenceNumber: sequenceNumber + 1,
        isDescriptionOnly: isDescriptionOnly,
        transactionItemTypeId: transactionItemTypeId,
        taxIncomeTypeId: taxIncomeTypeId,
        preVatAmount: transactionItemPreVatAmount,
        vatAmount: transactionItemVatAmount,
        itemWhtPercent: itemWhtPercent,
        itemNetTotal: itemNetTotal,
        netAmountWithAllocateDiscount: netAmountWithAllocateDiscount,
        toCurrencyVatTotal: toCurrencyVatTotal,
        toCurrencyPreVatTotal: toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: toCurrencyVatExemptedTotal,
        toCurrencyNetTotal: toCurrencyNetTotal,
        toCurrencySubTotalForcalculateWHT: toCurrencySubTotalForcalculateWHT,
        fromCurrencyPrice: fromCurrencyPrice,
        fromCurrencyDiscount: fromCurrencyDiscount,
        fromCurrencyWHTTotal: fromCurrencyWHTTotal,
        fromCurrencyNetTotal: fromCurrencyNetTotal,
        fromCurrencyVatTotal: fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: fromCurrencySubTotalForcalculateWHT,
      };
      transactionItemList.push(transactionItem);
    }

    sameProductVatTypeId =
      transactionItemVatTypeIdSet.size === 1 ? defaultTransactionItemVatTypeId : Enums.ProductVatType.NotDefined; // check if all items is same VAT type
  }

  return {
    transactionItemList: transactionItemList,
    total: total,
    sameProductVatTypeId: sameProductVatTypeId,
    sameProductVatTypeIdTransactionItemTypeProduct: sameProductVatTypeIdTransactionItemTypeProduct,
    isServiceOnly: isServiceOnly,
    totalForCalculateTransactionDiscount: totalForCalculateTransactionDiscount,
  };
};

export const SetTransactionItemList = (transaction, transactionItemModel) => {
  if (
    transaction &&
    transaction.transactionItemList &&
    transactionItemModel &&
    transactionItemModel.transactionItemList &&
    transaction.transactionItemList.length == transactionItemModel.transactionItemList.length
  ) {
    for (let i = 0; i < transaction.transactionItemList.length; i++) {
      const transactionItemFromTransaction = transaction.transactionItemList[i];
      const transactionItemFromTransactionItemModel = transactionItemModel.transactionItemList[i];

      transactionItemFromTransaction.itemWht.percent = transactionItemFromTransactionItemModel.itemWhtPercent;
      transactionItemFromTransaction.vatTypeId.value = transactionItemFromTransactionItemModel.vatTypeId;
      transactionItemFromTransaction.itemWht.value = transactionItemFromTransactionItemModel.whtAmount;
      transactionItemFromTransaction.itemPreVatTotal =
        transactionItemFromTransactionItemModel.preVatAmount.FormatMoney();
      transactionItemFromTransaction.itemVatTotal = transactionItemFromTransactionItemModel.vatAmount.FormatMoney();
      transactionItemFromTransaction.itemNetTotal = transactionItemFromTransactionItemModel.itemNetTotal;
      transactionItemFromTransaction.itemNetAmountWithAllocateDiscountTotal =
        transactionItemFromTransactionItemModel.netAmountWithAllocateDiscount.FormatMoney();
      transactionItemFromTransaction.toCurrencyPrice = transactionItemFromTransactionItemModel.price.ToNumber();
      transactionItemFromTransaction.toCurrencyDiscount = transactionItemFromTransactionItemModel.discount.ToNumber();
      transactionItemFromTransaction.toCurrencyWHTTotal = transactionItemFromTransactionItemModel.whtAmount
        ? transactionItemFromTransactionItemModel.whtAmount.ToNumber()
        : 0;
      transactionItemFromTransaction.toCurrencyVatTotal = transactionItemFromTransactionItemModel.toCurrencyVatTotal;
      transactionItemFromTransaction.toCurrencyPreVatTotal =
        transactionItemFromTransactionItemModel.toCurrencyPreVatTotal;
      transactionItemFromTransaction.toCurrencyZeroVatTotal =
        transactionItemFromTransactionItemModel.toCurrencyZeroVatTotal;
      transactionItemFromTransaction.toCurrencyVatExemptedTotal =
        transactionItemFromTransactionItemModel.toCurrencyVatExemptedTotal;
      transactionItemFromTransaction.toCurrencySubTotalForcalculateWHT =
        transactionItemFromTransactionItemModel.toCurrencySubTotalForcalculateWHT;
      transactionItemFromTransaction.toCurrencyNetTotal = transactionItemFromTransactionItemModel.toCurrencyNetTotal;
      transactionItemFromTransaction.fromCurrencyPrice = transactionItemFromTransactionItemModel.fromCurrencyPrice;
      transactionItemFromTransaction.fromCurrencyDiscount =
        transactionItemFromTransactionItemModel.fromCurrencyDiscount;
      transactionItemFromTransaction.fromCurrencyWHTTotal =
        transactionItemFromTransactionItemModel.fromCurrencyWHTTotal;
      transactionItemFromTransaction.fromCurrencyNetTotal =
        transactionItemFromTransactionItemModel.fromCurrencyNetTotal;
      transactionItemFromTransaction.fromCurrencyVatTotal =
        transactionItemFromTransactionItemModel.fromCurrencyVatTotal;
      transactionItemFromTransaction.fromCurrencyPreVatTotal =
        transactionItemFromTransactionItemModel.fromCurrencyPreVatTotal;
      transactionItemFromTransaction.fromCurrencyZeroVatTotal =
        transactionItemFromTransactionItemModel.fromCurrencyZeroVatTotal;
      transactionItemFromTransaction.fromCurrencyVatExemptedTotal =
        transactionItemFromTransactionItemModel.fromCurrencyVatExemptedTotal;
      transactionItemFromTransaction.fromCurrencySubTotalForcalculateWHT =
        transactionItemFromTransactionItemModel.fromCurrencySubTotalForcalculateWHT;
    }
  }
};

function ConvertTransactionListForCalculateAllocateDiscountPercent(transactionItemList) {
  let transactionListForCalculateAllocateDiscountPercent = [];
  for (const transactionItem of transactionItemList) {
    let _transactionItem = {
      netAmount: transactionItem.itemPreVatTotal ? transactionItem.itemPreVatTotal.ToNumber() : 0,
      vatType: transactionItem.vatTypeId ? transactionItem.vatTypeId.value : Enums.ProductVatType.None,
    };
    transactionListForCalculateAllocateDiscountPercent.push(_transactionItem);
  }
  return transactionListForCalculateAllocateDiscountPercent;
}

function ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
  taxStatus,
  transactionItemPrice,
  transactionItemDiscount,
  transactionItemDiscountTypeId,
  transactionItemAmount,
  transactionItemVatType
) {
  let transactionItemTotal = 0;
  let transactionItemPreVatAmount = 0;
  let transactionItemPriceTotal = 0;

  if (transactionItemDiscountTypeId === 1) {
    transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(
      transactionItemPrice,
      peakUtility.PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionItemPrice, transactionItemDiscount),
        100
      )
    );
  } else {
    transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
  }

  transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);

  if (taxStatus === Enums.TaxTypeId.IncludeTax) {
    if (transactionItemVatType === Enums.ProductVatType.SevenPercent) {
      transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
        100
      );
    } else {
      transactionItemPreVatAmount = transactionItemTotal;
    }
  } else {
    transactionItemPreVatAmount = transactionItemTotal;
  }

  return transactionItemPreVatAmount;
}

function ConvertTransactionItemForCalculateProductTotalPrice(transactionItem) {
  let transactionItemForCalculateProductTotalPrice = {
    price: transactionItem.price ? transactionItem.price.value.ToNumber() : 0,
    discount: transactionItem.discount ? transactionItem.discount.value.ToNumber() : 0,
    discountType: transactionItem.discount ? transactionItem.discount.discountTypeId : Enums.DiscountType.Currency,
    amount: transactionItem.amount ? transactionItem.amount.value.ToNumber() : 0,
    vatType: transactionItem.vatTypeId ? transactionItem.vatTypeId.value : Enums.ProductVatType.None,
  };
  return transactionItemForCalculateProductTotalPrice;
}

function CalculateAllocateDiscountPercent(transactionItemList, transactionDiscount, transctionDiscountType, taxStatus) {
  let allProductVatType = Enums.ProductVatType.None;
  let allocateDiscountPercent = 0;
  transactionDiscount = transactionDiscount ? transactionDiscount.ToNumber() : 0;
  if (transactionDiscount != 0) {
    if (transctionDiscountType == Enums.DiscountType.Currency) {
      let allProductNetAmount = 0;
      for (const item of transactionItemList) {
        if (item.netAmount > 0) {
          allProductNetAmount += item.netAmount;
          allProductVatType = item.vatType;
        }
      }
      if (taxStatus == Enums.TaxTypeId.IncludeTax) {
        if (allProductVatType == Enums.ProductVatType.SevenPercent) {
          transactionDiscount = transactionDiscount / ((100 + vatPercent) / 100);
        }
      }
      allocateDiscountPercent = allProductNetAmount != 0 ? (transactionDiscount * 100) / allProductNetAmount : 0;
    } else {
      allocateDiscountPercent = transactionDiscount;
    }
  }
  return allocateDiscountPercent;
}

function GetAllocationItemListWithOutZeroPercent(allocation) {
  let allocationItemList = [];

  if (allocation.allocationItemList && allocation.allocationItemList.length > 0) {
    allocation.allocationItemList.forEach((allocationItem) => {
      if (allocationItem.allocationItemId > 0 && allocationItem.allocationPercent > 0) {
        allocationItemList.push(allocationItem);
      }
    });
  }

  return allocationItemList;
}

export const GetAllocationListWithOutZeroPercent = (allocationTransactionList) => {
  let allocationList = [];

  if (allocationTransactionList && allocationTransactionList.length > 0) {
    allocationTransactionList.forEach((allocation) => {
      let allocationItemList = GetAllocationItemListWithOutZeroPercent(allocation);
      if (allocationItemList.length > 0) {
        let allocationTemplate = {
          allocationId: allocation.allocationId,
          allocationItemList: allocationItemList,
        };
        allocationList.push(allocationTemplate);
      }
    });
  }

  return allocationList;
};

function CalculateProductTotalPrice(
  transactionItem,
  allocateDiscountPercent,
  transactionToCurrencyUId,
  transactionExchangeRate,
  transactionRatio,
  transactionTaxStatus,
  isMerchantVat,
  transactionType,
  financeType,
  isCalculateCurrency = true
) {
  let productPrice = transactionItem.price;

  if (transactionItem.discount != 0) {
    let productDiscount = 0;
    if (transactionItem.discountType == Enums.DiscountType.Percent) {
      productDiscount = (productPrice * transactionItem.discount) / 100;
    } else {
      productDiscount = transactionItem.discount;
    }
    productPrice = productPrice - productDiscount;
  }
  let productNetAmountWithAllocateDiscount = productPrice * transactionItem.amount;
  if (transactionToCurrencyUId != 0 && isCalculateCurrency) {
    productNetAmountWithAllocateDiscount =
      (productNetAmountWithAllocateDiscount * transactionExchangeRate) / transactionRatio;
  }
  if (transactionTaxStatus != Enums.TaxTypeId.ExcludeTax) {
    if (transactionItem.vatType == Enums.ProductVatType.SevenPercent) {
      productNetAmountWithAllocateDiscount = (productNetAmountWithAllocateDiscount / (100 + vatPercent)) * 100;
    }
  }
  if (allocateDiscountPercent != 0 && productNetAmountWithAllocateDiscount > 0) {
    productNetAmountWithAllocateDiscount =
      productNetAmountWithAllocateDiscount * ((100 - allocateDiscountPercent) / 100);
  }

  return productNetAmountWithAllocateDiscount;
}

function GetTransactionItemWhtPercent(whtAmountType) {
  let transactionItemWhtPercent = 0;
  switch (whtAmountType) {
    case Enums.WhtAmountType.NotSpecify.type:
      transactionItemWhtPercent = Enums.WhtAmountType.NotSpecify.value;
      break;
    case Enums.WhtAmountType.None.type:
      transactionItemWhtPercent = Enums.WhtAmountType.None.value;
      break;
    case Enums.WhtAmountType.ZeroPointSevenFive.type:
      transactionItemWhtPercent = Enums.WhtAmountType.ZeroPointSevenFive.value;
      break;
    case Enums.WhtAmountType.OnePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.OnePercent.value;
      break;
    case Enums.WhtAmountType.OnePointFivePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.OnePointFivePercent.value;
      break;
    case Enums.WhtAmountType.TwoPercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.TwoPercent.value;
      break;
    case Enums.WhtAmountType.ThreePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.ThreePercent.value;
      break;
    case Enums.WhtAmountType.FivePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.FivePercent.value;
      break;
    case Enums.WhtAmountType.TenPercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.TenPercent.value;
      break;
    case Enums.WhtAmountType.FifteenPercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.FifteenPercent.value;
      break;
    case Enums.WhtAmountType.Custom.type:
      transactionItemWhtPercent = Enums.WhtAmountType.Custom.value;
      break;
  }
  return transactionItemWhtPercent;
}
function GetAllocationItemPercentDictaionary(allocationList) {
  const allocationItemPercentDictionary = {};
  for (const allocation of allocationList) {
    if (allocation && allocation.allocationItemList) {
      for (const allocationItem of allocation.allocationItemList) {
        if (allocationItem && allocationItem.allocationItemId > 0 && allocationItem.allocationPercent > 0) {
          allocationItemPercentDictionary[allocationItem.allocationItemId] = allocationItem;
        }
      }
    }
  }
  return allocationItemPercentDictionary;
}
function CheckAllocationEqual(allocationListSource, allocationListDestination) {
  let isEqual = true;
  const allocationItemPercentDictionary = GetAllocationItemPercentDictaionary(allocationListDestination);
  for (const allocationSource of allocationListSource) {
    if (allocationSource && allocationSource.allocationItemList) {
      for (const allocationItem of allocationSource.allocationItemList) {
        if (allocationItem && allocationItem.allocationItemId > 0 && allocationItem.allocationPercent > 0) {
          const selectedAllocationItem = allocationItemPercentDictionary[allocationItem.allocationItemId];
          if (selectedAllocationItem) {
            if (
              allocationItem.allocationPercent.ToAccountingRoundUpNumber() !=
              selectedAllocationItem.allocationPercent.ToAccountingRoundUpNumber()
            ) {
              isEqual = false;
            }
            if (allocationItem.allocationValueType != selectedAllocationItem.allocationValueType) {
              isEqual = false;
            }
          } else {
            isEqual = false;
          }
        }
      }
    }
  }
  return isEqual;
}
export const GetTransactionItemSummary = (_transaction, transactionItemModel, referenceDepositSummary) => {
  let vatExemptedTotal = 0;
  let zeroVatTotal = 0;
  let sevenVatTotal = 0;
  let vatExemptedTotalWithOutTransactionDiscount = 0;
  let zeroVatTotalWithOutTransactionDiscount = 0;
  let sevenVatTotalWithOutTransactionDiscount = 0;
  let whtTotal = 0;
  let amountBeforeDiscount = 0;

  const isOnlyNoneOrNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem) => transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0
    ).length > 0
      ? false
      : true;
  const isHaveSomeNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem) => transactionItem.whtAmountTypeId === Enums.WhtAmountType.NotSpecify.type
    ).length > 0;
  const isNoneOrNotSpecifyWht = isHaveSomeNotSpecifyWht && isOnlyNoneOrNotSpecifyWht;
  let subTotalForCalculate = 0;

  for (const transactionItem of transactionItemModel.transactionItemList) {
    let discountTransactionPerProduct = 0;
    amountBeforeDiscount += transactionItem.transactionItemTotal;
    if (transactionItem.transactionItemTotal > 0) {
      discountTransactionPerProduct = GetDiscountTransactionPerProduct(
        _transaction.transactionDiscount.value,
        _transaction.transactionDiscount.discountType,
        transactionItem.transactionItemTotal,
        transactionItemModel.totalForCalculateTransactionDiscount
      );
    }
    //Depend on taxStatus
    const transactionItemTotalWithDiscount = peakUtility.PeakOperatorSubtract(
      transactionItem.transactionItemTotal,
      discountTransactionPerProduct
    );

    switch (transactionItem.vatTypeId.ToNumber()) {
      case 3:
        sevenVatTotal = peakUtility.PeakOperatorAdd(sevenVatTotal, transactionItemTotalWithDiscount);
        sevenVatTotalWithOutTransactionDiscount = peakUtility.PeakOperatorAdd(
          sevenVatTotalWithOutTransactionDiscount,
          transactionItem.transactionItemTotal
        );
        break;
      case 2:
        zeroVatTotal = peakUtility.PeakOperatorAdd(zeroVatTotal, transactionItemTotalWithDiscount);
        zeroVatTotalWithOutTransactionDiscount = peakUtility.PeakOperatorAdd(
          zeroVatTotalWithOutTransactionDiscount,
          transactionItem.transactionItemTotal
        );
        break;
      default:
        vatExemptedTotal = peakUtility.PeakOperatorAdd(vatExemptedTotal, transactionItemTotalWithDiscount);
        vatExemptedTotalWithOutTransactionDiscount = peakUtility.PeakOperatorAdd(
          vatExemptedTotalWithOutTransactionDiscount,
          transactionItem.transactionItemTotal
        );
        break;
    }
  }

  for (const transactionItem of transactionItemModel.transactionItemList) {
    let depositTransactionPerProduct = 0;
    let discountTransactionPerProduct = 0;
    if (transactionItem.transactionItemTotal > 0) {
      discountTransactionPerProduct = GetDiscountTransactionPerProduct(
        _transaction.transactionDiscount.value,
        _transaction.transactionDiscount.discountType,
        transactionItem.transactionItemTotal,
        transactionItemModel.totalForCalculateTransactionDiscount
      );
      depositTransactionPerProduct = GetDepositTransactionPerProduct(
        transactionItem.vatTypeId,
        transactionItem.transactionItemTotal,
        sevenVatTotalWithOutTransactionDiscount,
        zeroVatTotalWithOutTransactionDiscount,
        vatExemptedTotalWithOutTransactionDiscount,
        referenceDepositSummary.toCurrencyPreVatTotal,
        referenceDepositSummary.toCurrencyZeroVatTotal,
        referenceDepositSummary.toCurrencyVatExemptedTotal
      );
    }

    let transactionItemPreVatTotalWithDiscount = 0;
    if (_transaction.taxStatus.value === Enums.TaxTypeId.IncludeTax) {
      let discountForIncludeTax = 0;
      if (transactionItem.vatTypeId === Enums.ProductVatType.SevenPercent) {
        discountForIncludeTax = (discountTransactionPerProduct * 100) / 107;
      } else {
        discountForIncludeTax = discountTransactionPerProduct;
      }
      transactionItemPreVatTotalWithDiscount = peakUtility.PeakOperatorSubtract(
        transactionItem.preVatAmount,
        discountForIncludeTax
      );
    } else {
      transactionItemPreVatTotalWithDiscount = peakUtility.PeakOperatorSubtract(
        transactionItem.preVatAmount,
        discountTransactionPerProduct
      );
    }

    const transactionItemPreVatTotalWithDiscountAndDeposit = peakUtility.PeakOperatorSubtract(
      transactionItemPreVatTotalWithDiscount,
      depositTransactionPerProduct
    );

    if (isNoneOrNotSpecifyWht && transactionItem.whtAmountTypeId === Enums.WhtAmountType.NotSpecify.type) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(
        subTotalForCalculate,
        transactionItemPreVatTotalWithDiscountAndDeposit
      );
    } else if (!isNoneOrNotSpecifyWht && (transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0)) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(
        subTotalForCalculate,
        transactionItemPreVatTotalWithDiscountAndDeposit
      );
    }

    if (transactionItem.whtAmount != null && transactionItemPreVatTotalWithDiscountAndDeposit != 0) {
      if (transactionItemPreVatTotalWithDiscountAndDeposit === transactionItem.preVatAmount) {
        whtTotal = peakUtility.PeakOperatorAdd(transactionItem.whtAmount, whtTotal);
      } else {
        const whtAmountPercent = peakUtility.PeakOperatorDivide(
          peakUtility.PeakOperatorMultiply(transactionItem.whtAmount, 100),
          transactionItem.preVatAmount
        );

        const whtTransactionItemWithDiscount = peakUtility.PeakOperatorDivide(
          peakUtility.PeakOperatorMultiply(whtAmountPercent, transactionItemPreVatTotalWithDiscountAndDeposit),
          100
        );

        whtTotal = peakUtility.PeakOperatorAdd(whtTransactionItemWithDiscount, whtTotal);
      }
    }
  }

  const total = peakUtility.PeakOperatorAdd(peakUtility.PeakOperatorAdd(vatExemptedTotal, zeroVatTotal), sevenVatTotal);

  return {
    amountBeforeDiscount: amountBeforeDiscount,
    vatExemptedTotal: vatExemptedTotal,
    zeroVatTotal: zeroVatTotal,
    sevenVatTotal: sevenVatTotal,
    total: total,
    subTotalForCalculate: subTotalForCalculate,
    whtTotal: whtTotal,
    isNoneOrNotSpecifyWht: isNoneOrNotSpecifyWht,
    isServiceOnly: transactionItemModel.isServiceOnly,
    sameProductVatTypeId: transactionItemModel.sameProductVatTypeId,
    sameProductVatTypeIdTransactionItemTypeProduct: transactionItemModel.sameProductVatTypeIdTransactionItemTypeProduct,
  };
};

function GetDiscountTransactionPerProduct(
  discount,
  discountType,
  transactionItemTotal,
  totalForCalculateTransactionDiscount
) {
  let discountTransactionPerProduct = 0;

  if (discountType === Enums.DiscountType.Percent) {
    discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
      peakUtility.PeakOperatorDivide(discount, 100),
      transactionItemTotal.ToNumber()
    );
  } else {
    discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
      peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), totalForCalculateTransactionDiscount.ToNumber()),
      discount.ToNumber()
    );
  }

  return discountTransactionPerProduct;
}

function GetDepositTransactionPerProduct(
  transactionItemVatTypeId,
  transactionItemTotal,
  fromCurrencyPreVatTotal,
  fromCurrencyZeroVatTotal,
  fromCurrencyVatExemptedTotal,
  fromCurrencyDepositPreVatTotal,
  fromCurrencyDepositZeroVatTotal,
  fromCurrencyDepositVatExemptedTotal
) {
  let depositTransactionPerProduct = 0;

  switch (transactionItemVatTypeId.ToNumber()) {
    case Enums.ProductVatType.SevenPercent:
      depositTransactionPerProduct = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), fromCurrencyPreVatTotal.ToNumber()),
        fromCurrencyDepositPreVatTotal.ToNumber()
      );
      break;
    case Enums.ProductVatType.ZeroPercent:
      depositTransactionPerProduct = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), fromCurrencyZeroVatTotal.ToNumber()),
        fromCurrencyDepositZeroVatTotal.ToNumber()
      );
      break;
    default:
      depositTransactionPerProduct = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), fromCurrencyVatExemptedTotal.ToNumber()),
        fromCurrencyDepositVatExemptedTotal.ToNumber()
      );
      break;
  }

  return depositTransactionPerProduct;
}
function GetReferenceTransactionSummary(
  _transaction,
  transactionWht,
  referenceTransactionAmount,
  currencyReferenceTransactionAmount
) {
  if (!_transaction.reference) return;

  if (!_transaction.reference.transactionSummary || !_transaction.reference.transactionCurrency) return;

  let transactionSummary = {
    netAmount: _transaction.reference.transactionSummary.netAmount,
    vatTotal: _transaction.reference.transactionSummary.vatTotal,
    preVatTotal: _transaction.reference.transactionSummary.preVatTotal,
    zeroVatTotal: _transaction.reference.transactionSummary.zeroVatTotal,
    vatExemptedTotal: _transaction.reference.transactionSummary.vatExemptedTotal,
    whtTotal: _transaction.reference.transactionSummary.whtTotal,
    subTotalForCalculateWht: _transaction.reference.transactionSummary.subTotalForCalculateWht,
    isServiceOnly: _transaction.reference.transactionSummary.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionWht.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionWht.sameProductVatTypeId.ToNumber(),
    referenceTransactionAmount: referenceTransactionAmount,
  };

  let transactionCurrencySummary = {
    netAmount: _transaction.reference.transactionCurrency.currencyNetAmount,
    vatTotal: _transaction.reference.transactionCurrency.currencyVatTotal,
    preVatTotal: _transaction.reference.transactionCurrency.currencyPreVatTotal,
    zeroVatTotal: _transaction.reference.transactionCurrency.currencyZeroVatTotal,
    vatExemptedTotal: _transaction.reference.transactionCurrency.currencyVatExemptedTotal,
    whtTotal: _transaction.reference.transactionCurrency.currencyWhtTotal,
    subTotalForCalculateWht: _transaction.reference.transactionCurrency.currencySubTotalForCalculateWht,
    referenceTransactionAmount: currencyReferenceTransactionAmount,
    amountBeforeDiscount: _transaction.reference.transactionCurrency.currencyNetAmount,
    referenceDepositTotal: 0,
    amountAfterDiscount: _transaction.reference.transactionCurrency.currencyNetAmount,
  };

  return {
    transactionSummary: transactionSummary,
    transactionCurrencySummary: transactionCurrencySummary,
    referenceDepositSummary: GetReferenceDepositSummary(_transaction),
  };
}

export const GetReferenceDepositSummary = (_transaction) => {
  const referenceDepositSummary = {
    fromCurrencyNetTotal: 0,
    fromCurrencyVatTotal: 0,
    fromCurrencyPreVatTotal: 0,
    fromCurrencyZeroVatTotal: 0,
    fromCurrencyVatExemptedTotal: 0,
    toCurrencyNetTotal: 0,
    toCurrencyVatTotal: 0,
    toCurrencyPreVatTotal: 0,
    toCurrencyZeroVatTotal: 0,
    toCurrencyVatExemptedTotal: 0,
  };

  if (_transaction.referenceDepositList && _transaction.referenceDepositList.length > 0) {
    for (const referenceDeposit of _transaction.referenceDepositList) {
      referenceDepositSummary.fromCurrencyNetTotal += referenceDeposit.fromCurrencyNetTotal;
      referenceDepositSummary.fromCurrencyVatTotal += referenceDeposit.fromCurrencyVatTotal;
      referenceDepositSummary.fromCurrencyPreVatTotal += referenceDeposit.fromCurrencyPreVatTotal;
      referenceDepositSummary.fromCurrencyZeroVatTotal += referenceDeposit.fromCurrencyZeroVatTotal;
      referenceDepositSummary.fromCurrencyVatExemptedTotal += referenceDeposit.fromCurrencyVatExemptedTotal;
      referenceDepositSummary.toCurrencyNetTotal += referenceDeposit.toCurrencyNetTotal;
      referenceDepositSummary.toCurrencyVatTotal += referenceDeposit.toCurrencyVatTotal;
      referenceDepositSummary.toCurrencyPreVatTotal += referenceDeposit.toCurrencyPreVatTotal;
      referenceDepositSummary.toCurrencyZeroVatTotal += referenceDeposit.toCurrencyZeroVatTotal;
      referenceDepositSummary.toCurrencyVatExemptedTotal += referenceDeposit.toCurrencyVatExemptedTotal;
    }
  }

  return referenceDepositSummary;
};

export const GetTransactionSummary = (_transaction, transactionItemModel) => {
  let taxStatus = _transaction.taxStatus.value;
  let currencyRatio = _transaction.transactionCurrencySummary.ratio;
  let currencyExchangeRates = _transaction.transactionCurrencySummary.exchangeRate;

  const referenceDepositSummary = GetReferenceDepositSummary(_transaction);
  const transactionItemSummaryModel = GetTransactionItemSummary(
    _transaction,
    transactionItemModel,
    referenceDepositSummary
  );

  let transactionWht = {
    subTotalForCalculate: transactionItemSummaryModel.subTotalForCalculate,
    whtTotal: transactionItemSummaryModel.whtTotal,
    isServiceOnly: transactionItemSummaryModel.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionItemSummaryModel.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionItemSummaryModel.sameProductVatTypeId,
    sameProductVatTypeIdTransactionItemTypeProduct:
      transactionItemSummaryModel.sameProductVatTypeIdTransactionItemTypeProduct,
  };

  let vatExemptedTotal = CalculateWithCurrencyUid(
    transactionItemSummaryModel.vatExemptedTotal,
    currencyExchangeRates,
    currencyRatio,
    _transaction.transactionCurrencySummary.toCurrencyUId
  );
  let zeroVatTotal = CalculateWithCurrencyUid(
    transactionItemSummaryModel.zeroVatTotal,
    currencyExchangeRates,
    currencyRatio,
    _transaction.transactionCurrencySummary.toCurrencyUId
  );

  vatExemptedTotal = peakUtility.PeakOperatorSubtract(
    vatExemptedTotal,
    referenceDepositSummary.fromCurrencyVatExemptedTotal
  );

  zeroVatTotal = peakUtility.PeakOperatorSubtract(zeroVatTotal, referenceDepositSummary.fromCurrencyZeroVatTotal);

  let referenceTransactionAmount = 0;
  let currencyReferenceTransactionAmount = 0;

  if (
    _transaction.transactionType == Enums.TransactionType.CreditNote ||
    _transaction.transactionType == Enums.TransactionType.DebitNote
  ) {
    if (_transaction.transactionReferenceAmount) {
      currencyReferenceTransactionAmount = _transaction.transactionReferenceAmount.value.ToNumber();
      referenceTransactionAmount = CalculateWithCurrencyUid(
        _transaction.transactionReferenceAmount.value.ToNumber(),
        currencyExchangeRates,
        currencyRatio,
        _transaction.transactionCurrencySummary.toCurrencyUId
      );
    }
  }

  if (
    _transaction.transactionType === Enums.TransactionType.CreditNote &&
    _transaction.reduceDebtType &&
    _transaction.reduceDebtType.value.id === Enums.ReduceDebtType.AllDebts &&
    _transaction.reference.referenceId > 0
  ) {
    let referenceTransactionSummary = GetReferenceTransactionSummary(
      _transaction,
      transactionWht,
      referenceTransactionAmount,
      currencyReferenceTransactionAmount
    );
    if (referenceTransactionSummary) return referenceTransactionSummary;
  }

  let currencyVatExemptedTotal = peakUtility
    .PeakOperatorSubtract(
      transactionItemSummaryModel.vatExemptedTotal,
      referenceDepositSummary.toCurrencyVatExemptedTotal
    )
    .ToAccountingRoundUpNumber();

  let currencyZeroVatTotal = peakUtility
    .PeakOperatorSubtract(transactionItemSummaryModel.zeroVatTotal, referenceDepositSummary.toCurrencyZeroVatTotal)
    .ToAccountingRoundUpNumber();
  let preVatTotal = 0;
  let vat = 0;
  let netAmount = 0;
  let currencyPreVatTotal = 0;
  let currencyVatTotal = 0;
  let currencyNetAmount = 0;
  let currencyAmountBeforeDiscount = transactionItemSummaryModel.amountBeforeDiscount.ToAccountingRoundUp();
  let currencyReferenceDepositTotal = 0;
  let currencyAmountAfterDiscount = 0;

  if (taxStatus.ToNumber() === Enums.TaxTypeId.ExcludeTax) {
    vat = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(
          CalculateWithCurrencyUid(
            transactionItemSummaryModel.sevenVatTotal,
            currencyExchangeRates,
            currencyRatio,
            _transaction.transactionCurrencySummary.toCurrencyUId
          ),
          vatPercent
        ),
        100
      )
      .ToAccountingRoundUpNumber();
    vat = peakUtility.PeakOperatorSubtract(vat, referenceDepositSummary.fromCurrencyVatTotal);

    preVatTotal = CalculateWithCurrencyUid(
      transactionItemSummaryModel.sevenVatTotal,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    );

    preVatTotal = peakUtility.PeakOperatorSubtract(preVatTotal, referenceDepositSummary.fromCurrencyPreVatTotal);

    netAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            preVatTotal.ToAccountingRoundUpNumber(),
            zeroVatTotal.ToAccountingRoundUpNumber()
          ),
          vatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        vat.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUpNumber();

    currencyPreVatTotal = peakUtility
      .PeakOperatorSubtract(transactionItemSummaryModel.sevenVatTotal, referenceDepositSummary.toCurrencyPreVatTotal)
      .ToAccountingRoundUpNumber();

    currencyVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility
          .PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, vatPercent),
            100
          )
          .ToAccountingRoundUpNumber(),
        referenceDepositSummary.toCurrencyVatTotal
      )
      .ToAccountingRoundUpNumber();
    currencyNetAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            currencyPreVatTotal.ToAccountingRoundUpNumber(),
            currencyZeroVatTotal.ToAccountingRoundUpNumber()
          ),
          currencyVatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        currencyVatTotal.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUpNumber();

    currencyReferenceDepositTotal = peakUtility
      .PeakOperatorSubtract(referenceDepositSummary.toCurrencyNetTotal, referenceDepositSummary.fromCurrencyVatTotal)
      .ToAccountingRoundUpNumber();
  } else {
    netAmount = CalculateWithCurrencyUid(
      transactionItemSummaryModel.total,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    ).ToAccountingRoundUpNumber();

    netAmount = peakUtility
      .PeakOperatorSubtract(netAmount, referenceDepositSummary.fromCurrencyNetTotal)
      .ToAccountingRoundUpNumber();

    let totalWithVat = peakUtility
      .PeakOperatorSubtract(peakUtility.PeakOperatorSubtract(netAmount, zeroVatTotal), vatExemptedTotal)
      .ToAccountingRoundUpNumber();
    vat = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(totalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUpNumber();
    preVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(
          peakUtility.PeakOperatorSubtract(netAmount, vat),
          zeroVatTotal.ToAccountingRoundUpNumber()
        ),
        vatExemptedTotal.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUpNumber();

    currencyNetAmount = peakUtility
      .PeakOperatorSubtract(transactionItemSummaryModel.total, referenceDepositSummary.toCurrencyNetTotal)
      .ToAccountingRoundUpNumber();
    let currencyTotalWithVat = peakUtility.PeakOperatorSubtract(
      peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyZeroVatTotal),
      currencyVatExemptedTotal
    );
    currencyVatTotal = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(currencyTotalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUpNumber();
    currencyPreVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(
          peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyVatTotal),
          currencyZeroVatTotal
        ),
        currencyVatExemptedTotal
      )
      .ToAccountingRoundUpNumber();
    currencyReferenceDepositTotal = referenceDepositSummary.toCurrencyNetTotal.ToAccountingRoundUpNumber();
  }

  currencyAmountAfterDiscount = peakUtility
    .PeakOperatorSubtract(transactionItemSummaryModel.total, currencyReferenceDepositTotal)
    .ToAccountingRoundUpNumber();

  let transactionSummary = {
    netAmount: netAmount.ToAccountingRoundUpNumber(),
    vatTotal: vat.ToAccountingRoundUpNumber(),
    preVatTotal: preVatTotal.ToAccountingRoundUpNumber(),
    zeroVatTotal: zeroVatTotal.ToAccountingRoundUpNumber(),
    vatExemptedTotal: vatExemptedTotal.ToAccountingRoundUpNumber(),
    whtTotal: CalculateWithCurrencyUid(
      transactionWht.whtTotal,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    ).ToAccountingRoundUpNumber(),
    subTotalForCalculateWht: CalculateWithCurrencyUid(
      transactionWht.subTotalForCalculate,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    ).ToAccountingRoundUpNumber(),
    isServiceOnly: transactionWht.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionWht.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionWht.sameProductVatTypeId.ToNumber(),
    sameProductVatTypeIdTransactionItemTypeProduct:
      transactionWht.sameProductVatTypeIdTransactionItemTypeProduct.ToNumber(),
    referenceTransactionAmount: referenceTransactionAmount,
    discount: CalculateWithCurrencyUid(
      _transaction.transactionDiscount.value.ToNumber(),
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    ).ToAccountingRoundUpNumber(),
  };

  let transactionCurrencySummary = {
    netAmount: currencyNetAmount.ToAccountingRoundUpNumber(),
    vatTotal: currencyVatTotal.ToAccountingRoundUpNumber(),
    preVatTotal: currencyPreVatTotal.ToAccountingRoundUpNumber(),
    zeroVatTotal: currencyZeroVatTotal.ToAccountingRoundUpNumber(),
    vatExemptedTotal: currencyVatExemptedTotal.ToAccountingRoundUpNumber(),
    whtTotal: transactionWht.whtTotal.ToAccountingRoundUpNumber(),
    subTotalForCalculateWht: transactionWht.subTotalForCalculate.ToAccountingRoundUpNumber(),
    referenceTransactionAmount: currencyReferenceTransactionAmount,
    amountBeforeDiscount: currencyAmountBeforeDiscount.ToAccountingRoundUpNumber(),
    referenceDepositTotal: currencyReferenceDepositTotal.ToAccountingRoundUpNumber(),
    amountAfterDiscount: currencyAmountAfterDiscount.ToAccountingRoundUpNumber(),
    discount: _transaction.transactionDiscount.value.ToNumber(),
  };

  return {
    transactionSummary: transactionSummary,
    transactionCurrencySummary: transactionCurrencySummary,
    referenceDepositSummary: referenceDepositSummary,
  };
};
function SetTransactionSummary(_transaction) {
  const transactionItemModel = GetTransactionItemList(_transaction);
  SetTransactionItemList(_transaction, transactionItemModel);

  const transactionSummaryModel = GetTransactionSummary(_transaction, transactionItemModel);

  if (!_transaction.isNotCalculateTransactionSummary) {
    _transaction.transactionCurrencySummary.discount = transactionSummaryModel.transactionCurrencySummary.discount;
    _transaction.transactionCurrencySummary.vatExemptedTotal =
      transactionSummaryModel.transactionCurrencySummary.vatExemptedTotal.FormatMoney();
    _transaction.transactionCurrencySummary.zeroVatTotal =
      transactionSummaryModel.transactionCurrencySummary.zeroVatTotal.FormatMoney();
    _transaction.transactionCurrencySummary.netAmount =
      transactionSummaryModel.transactionCurrencySummary.netAmount.FormatMoney();
    _transaction.transactionCurrencySummary.whtTotal =
      transactionSummaryModel.transactionCurrencySummary.whtTotal.FormatMoney();
    _transaction.transactionCurrencySummary.vat.disabled =
      _transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
    _transaction.transactionCurrencySummary.vat.isActive = false;
    _transaction.transactionCurrencySummary.amountBeforeDiscount =
      transactionSummaryModel.transactionCurrencySummary.amountBeforeDiscount.FormatMoney();
    _transaction.transactionCurrencySummary.referenceDepositTotal =
      transactionSummaryModel.transactionCurrencySummary.referenceDepositTotal.FormatMoney();
    _transaction.transactionCurrencySummary.amountAfterDiscount =
      transactionSummaryModel.transactionCurrencySummary.amountAfterDiscount.FormatMoney();

    _transaction.transactionSummary.discount = transactionSummaryModel.transactionSummary.discount;
    _transaction.transactionSummary.vatExemptedTotal =
      transactionSummaryModel.transactionSummary.vatExemptedTotal.FormatMoney();
    _transaction.transactionSummary.zeroVatTotal =
      transactionSummaryModel.transactionSummary.zeroVatTotal.FormatMoney();
    _transaction.transactionSummary.netAmount = transactionSummaryModel.transactionSummary.netAmount.FormatMoney();
    _transaction.transactionSummary.vat.disabled =
      _transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
    _transaction.transactionSummary.vat.isActive = false;
    _transaction.transactionSummary.subTotalForCalculateWht =
      transactionSummaryModel.transactionSummary.subTotalForCalculateWht;
    _transaction.transactionSummary.remainPaymentNetAmount = transactionSummaryModel.transactionSummary.netAmount;
    _transaction.transactionSummary.remainWhtPaymentNetAmount = transactionSummaryModel.transactionSummary.whtTotal;
    _transaction.transactionSummary.paymentWht = {
      whtTotal: transactionSummaryModel.transactionSummary.whtTotal.FormatMoney(),
      paymentNetAmount: peakUtility
        .PeakOperatorSubtract(
          transactionSummaryModel.transactionSummary.netAmount,
          transactionSummaryModel.transactionSummary.whtTotal
        )
        .FormatMoney(),
      isShow: transactionSummaryModel.transactionSummary.whtTotal != 0,
    };

    if (_transaction.referenceDepositSummary) {
      _transaction.referenceDepositSummary.fromCurrencyDepositVatTotal =
        transactionSummaryModel.referenceDepositSummary.fromCurrencyVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal =
        transactionSummaryModel.referenceDepositSummary.fromCurrencyPreVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal =
        transactionSummaryModel.referenceDepositSummary.fromCurrencyZeroVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal =
        transactionSummaryModel.referenceDepositSummary.fromCurrencyVatExemptedTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositVatTotal =
        transactionSummaryModel.referenceDepositSummary.toCurrencyVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal =
        transactionSummaryModel.referenceDepositSummary.toCurrencyPreVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal =
        transactionSummaryModel.referenceDepositSummary.toCurrencyZeroVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal =
        transactionSummaryModel.referenceDepositSummary.toCurrencyVatExemptedTotal.FormatMoney();
    }

    if (!_transaction.isNotAuto) {
      _transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
        transactionSummaryModel.transactionCurrencySummary.preVatTotal;
      _transaction.transactionCurrencySummary.vat.preVatTotal =
        transactionSummaryModel.transactionCurrencySummary.preVatTotal.FormatMoney();
      _transaction.transactionCurrencySummary.vat.vatTotalDefualt =
        transactionSummaryModel.transactionCurrencySummary.vatTotal;
      _transaction.transactionCurrencySummary.vat.vatTotal =
        transactionSummaryModel.transactionCurrencySummary.vatTotal.FormatMoney();
      _transaction.transactionSummary.vat.preVatTotalDefualt = transactionSummaryModel.transactionSummary.preVatTotal;
      _transaction.transactionSummary.vat.preVatTotal =
        transactionSummaryModel.transactionSummary.preVatTotal.FormatMoney();
      _transaction.transactionSummary.vat.vatTotalDefualt = transactionSummaryModel.transactionSummary.vatTotal;
      _transaction.transactionSummary.vat.vatTotal = transactionSummaryModel.transactionSummary.vatTotal.FormatMoney();
      _transaction.transactionSummary.isServiceOnly = transactionSummaryModel.transactionSummary.isServiceOnly;
      _transaction.transactionSummary.isNoneOrNotSpecifyWht =
        transactionSummaryModel.transactionSummary.isNoneOrNotSpecifyWht;
      _transaction.transactionSummary.sameProductVatType =
        transactionSummaryModel.transactionSummary.sameProductVatTypeId;
      _transaction.transactionSummary.sameProductVatTypeIdTransactionItemTypeProduct =
        transactionSummaryModel.transactionSummary.sameProductVatTypeIdTransactionItemTypeProduct;
    }

    if (
      _transaction.transactionType == Enums.TransactionType.CreditNote ||
      _transaction.transactionType == Enums.TransactionType.DebitNote
    ) {
      if (_transaction.transactionReferenceAmount) {
        _transaction.transactionReferenceAmount.value =
          transactionSummaryModel.transactionCurrencySummary.referenceTransactionAmount.FormatMoney();
      }
    }
  }
}
function SetIssueTaxInvoiceForImport(_transaction, merchantSetting) {
  let transactionType = _transaction.transactionType;
  let financeType = _transaction.financeType;
  let sameProductVatType = _transaction.transactionSummary.sameProductVatType;

  if (!merchantSetting.isVat) {
    _transaction.issueTaxInvoice.value = false;
  } else if (
    (transactionType === Enums.TransactionType.Invoice || transactionType === Enums.TransactionType.Receipt) &&
    financeType === Enums.FinanceType.InFlow
  ) {
    if (sameProductVatType === Enums.ProductVatType.None && !merchantSetting.canCreateTaxInvoiceNotVat) {
      _transaction.issueTaxInvoice.value = false;
    }
  }
}
function GetCurrencyMenuList() {
  let keys = Object.keys(Enums.CurrencyCode);
  let values = Object.values(Enums.CurrencyCode);
  let currencyList = [];
  for (let index = 0; index < keys.length; index++) {
    currencyList.push({ currencyCode: keys[index], value: values[index] });
  }
  return currencyList;
}
function GetCurrencyCodeByUid(currencyUid) {
  return GetCurrencyMenuList().find((x) => x.value === currencyUid);
}
function CalculateWithCurrencyUid(currencyAmount, exchangeRates, currencyRatio, toCurrencyUid) {
  if (toCurrencyUid === Enums.CurrencyCode.THB) {
    return currencyAmount;
  } else {
    const netAmount = peakUtility.PeakOperatorDivide(
      peakUtility.PeakOperatorMultiply(currencyAmount, exchangeRates),
      currencyRatio
    );
    return netAmount;
  }
}
export const ConvertToReferenceDepositList = (depositTransactionList) => {
  const referenceDepositList = [];
  if (depositTransactionList && depositTransactionList.length > 0) {
    for (const depositTransaction of depositTransactionList) {
      referenceDepositList.push({
        depositId: depositTransaction.id,
        depositNumber: depositTransaction.number,
        date: depositTransaction.date,
        fromCurrencyWHTTotal: depositTransaction.selectedFromCurrencyWHTTotal,
        fromCurrencyNetTotal: depositTransaction.selectedFromCurrencyNetTotal,
        fromCurrencyVatTotal: depositTransaction.selectedFromCurrencyVatTotal,
        fromCurrencyPreVatTotal: depositTransaction.selectedFromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: depositTransaction.selectedFromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: depositTransaction.selectedFromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: depositTransaction.selectedFromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: depositTransaction.selectedToCurrencyWHTTotal,
        toCurrencyNetTotal: depositTransaction.selectedToCurrencyNetTotal,
        toCurrencyVatTotal: depositTransaction.selectedToCurrencyVatTotal,
        toCurrencyPreVatTotal: depositTransaction.selectedToCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: depositTransaction.selectedToCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: depositTransaction.selectedToCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: depositTransaction.selectedToCurrencySubTotalForcalculateWHT,
      });
    }
  }
  return referenceDepositList;
};

export const GetCreateReferenceDepositSummaryDefualt = () => {
  return {
    fromCurrencyDepositVatTotal: "0.00",
    fromCurrencyDepositPreVatTotal: "0.00",
    fromCurrencyDepositZeroVatTotal: "0.00",
    fromCurrencyDepositVatExemptedTotal: "0.00",
    toCurrencyDepositVatTotal: "0.00",
    toCurrencyDepositPreVatTotal: "0.00",
    toCurrencyDepositZeroVatTotal: "0.00",
    toCurrencyDepositVatExemptedTotal: "0.00",
  };
};

export const ReconcileTransactionWithReferenceTransaction = (transaction, referenceTransaction) => {
  let transactionReferenceTransactionModel = null;
  let alertMessage = "";
  let canReferenceTransaction = true;
  let canReconcileTranFully = false;
  let canReconcileRefTranFully = false;
  const referenceTransactionItemDic = GetReferenceTransactionItemDic(referenceTransaction);
  if (transaction.taxStatus != referenceTransaction.taxStatus) {
    canReferenceTransaction = false;
    alertMessage = i18n.t("GoodsReceiptNotMatchInvoiceReceiptPricingType_Exception");
    return { transactionReferenceTransactionModel, canReconcileTranFully, alertMessage };
  }
  if (transaction.discountType != referenceTransaction.discountType) {
    canReferenceTransaction = false;
    alertMessage = i18n.t("GoodsReceiptNotMatchInvoiceReceiptDiscountType_Exception");
    return { transactionReferenceTransactionModel, canReconcileTranFully, alertMessage };
  }
  if (transaction.transactionItemList && transaction.transactionItemList.length) {
    for (const transactionItem of transaction.transactionItemList) {
      const keyValue = GetKeyValueTransactionItemForReconcile(transactionItem);
      if (referenceTransactionItemDic.has(keyValue)) {
        const referenceTransactionItemFromDic = referenceTransactionItemDic.get(keyValue);
        ReconcileReferenceTransactionItem(transactionItem, referenceTransactionItemFromDic);
      }
    }
  }
  ({ canReconcileTranFully, canReconcileRefTranFully } = CheckReferenceTransactionItemIsReconcileFully(
    transaction,
    referenceTransactionItemDic
  ));
  if (!(canReconcileTranFully || canReconcileRefTranFully)) {
    canReferenceTransaction = false;
    alertMessage = i18n.t("Mismatch_Product_List_Or_Product_Price");
  }
  if (canReferenceTransaction) {
    transactionReferenceTransactionModel = GetReconcileReferenceTransactionModel(
      referenceTransaction,
      referenceTransactionItemDic
    );
  }
  return { transactionReferenceTransactionModel, canReconcileTranFully, alertMessage };
};
export const SetAccountValidateError = (transactionCreate) => {
  if (transactionCreate && transactionCreate.transactionItemList) {
    for (const transactionItem of transactionCreate.transactionItemList) {
      if (!transactionItem.isDescriptionOnly) {
        if (transactionItem.account.id > 0) {
          transactionItem.account.validateError = false;
        } else {
          transactionItem.account.validateError = true;
        }
      }
    }
  }
};

export const TransactionValidateAccountBase = (transaction) => {
  if (transaction && transaction.transactionItemList) {
    for (const transactionItem of transaction.transactionItemList) {
      if (
        !transactionItem.isDescriptionOnly &&
        !(transactionItem.fixedAssetTemplate && transactionItem.fixedAssetTemplate.isService)
      ) {
        if (!transactionItem.account || transactionItem.account.id == 0) {
          return true;
        }
      }
    }
  }
  return false;
};

export const GetReconcileReferenceTransactionModel = (referenceTransaction, referenceTransactionItemDic) => {
  const transactionReferenceTransactionModel = {
    referenceTransactionId: referenceTransaction.id,
    transactionItemList: GetReconcileReferenceTransactionItemList(
      referenceTransaction.transactionItemList,
      referenceTransactionItemDic
    ),
  };
  //ถ้าทำpartialต้องมาแก้
  SetFullReferenceInvoiceReceiptSummary(transactionReferenceTransactionModel, referenceTransaction);
  //SetReferenceInvoiceReceiptSummary(transactionReferenceTransactionModel);
  return transactionReferenceTransactionModel;
};
export const CheckReferenceTransactionItemIsReconcileFully = (transaction, referenceTransactionItemDic) => {
  let canReconcileTranFully = true;
  let canReconcileRefTranFully = true;
  if (referenceTransactionItemDic && referenceTransactionItemDic.size > 0) {
    referenceTransactionItemDic.forEach((value, key) => {
      if (canReconcileRefTranFully && value.transactionItemList && value.transactionItemList.length) {
        for (const transactionItem of value.transactionItemList) {
          if (transactionItem.quantity > 0) {
            canReconcileRefTranFully = false;
            break;
          }
        }
      }
    });
  }
  if (transaction && transaction.transactionItemList && transaction.transactionItemList.length) {
    for (const transactionItem of transaction.transactionItemList) {
      if (canReconcileTranFully) {
        if (transactionItem.remainingQuantity > 0) {
          const keyValue = GetKeyValueTransactionItemForReconcile(transactionItem);
          if (referenceTransactionItemDic.has(keyValue)) {
            const referenceTransactionItemFromDic = referenceTransactionItemDic.get(keyValue);
            let referenceTransactionSelectedItem = referenceTransactionItemFromDic.referenceTransactionItemList.filter(
              (item) => item.transactionItemId == transactionItem.id
            );
            let sumQuantityAlreadyRef = referenceTransactionSelectedItem.reduce((sum, ref) => sum + ref.quantity, 0);
            if (transactionItem.remainingQuantity != sumQuantityAlreadyRef) {
              canReconcileTranFully = false;
            }
          } else {
            canReconcileTranFully = false;
          }
        }
      }
    }
  }
  return { canReconcileTranFully, canReconcileRefTranFully };
};

export const CheckReferenceTransactionItemExcess = (referenceTransactionItemDic) => {
  let canReferenceTransaction = true;
  if (referenceTransactionItemDic && referenceTransactionItemDic.size > 0) {
    referenceTransactionItemDic.forEach((value, key) => {
      if (canReferenceTransaction && value.transactionItemList && value.transactionItemList.length) {
        for (const transactionItem of value.transactionItemList) {
          if (transactionItem.quantity > 0) {
            canReferenceTransaction = false;
            break;
          }
        }
      }
    });
  }
  return canReferenceTransaction;
};

export const GetReconcileReferenceTransactionItemList = (transactionItemRawList, referenceTransactionItemDic) => {
  const transactionItemList = [];

  if (referenceTransactionItemDic) {
    const transactionItemRawListDic = GetTransactionItemListDic(transactionItemRawList);
    const referenceTransactionItemDicGroupByReferenceTransactionItemId =
      GetReferenceTransactionItemDicGroupByReferenceTransactionItemId(referenceTransactionItemDic);

    if (
      referenceTransactionItemDicGroupByReferenceTransactionItemId &&
      referenceTransactionItemDicGroupByReferenceTransactionItemId.size > 0
    ) {
      referenceTransactionItemDicGroupByReferenceTransactionItemId.forEach((value, key) => {
        if (transactionItemRawListDic.has(key)) {
          const transactionItemFromDic = transactionItemRawListDic.get(key);
          if (value && value.length > 0) {
            const mockTransactionItemList = [];
            const mockTransactionItemFromDic = { ...transactionItemFromDic };
            for (const referenceTransactionItemFromDic of value) {
              const transactionItem = {
                referenceTransactionItemId: referenceTransactionItemFromDic.referenceTransactionItemId,
                transactionItemId: referenceTransactionItemFromDic.transactionItemId,
                quantity: referenceTransactionItemFromDic.quantity,
                fromCurrencyWHTTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.fromCurrencyWHTTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                fromCurrencyNetTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.fromCurrencyNetTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                fromCurrencyVatTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.fromCurrencyVatTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                fromCurrencyPreVatTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.fromCurrencyPreVatTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                fromCurrencyZeroVatTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.fromCurrencyZeroVatTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                fromCurrencyVatExemptedTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.fromCurrencyVatExemptedTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                fromCurrencySubTotalForcalculateWHT: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.fromCurrencySubTotalForcalculateWHT,
                  referenceTransactionItemFromDic.quantity
                ),
                toCurrencyWHTTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.toCurrencyWHTTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                toCurrencyNetTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.toCurrencyNetTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                toCurrencyVatTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.toCurrencyVatTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                toCurrencyPreVatTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.toCurrencyPreVatTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                toCurrencyZeroVatTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.toCurrencyZeroVatTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                toCurrencyVatExemptedTotal: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.toCurrencyVatExemptedTotal,
                  referenceTransactionItemFromDic.quantity
                ),
                toCurrencySubTotalForcalculateWHT: CalculateRuleOfThreeReconcileTransaction(
                  transactionItemFromDic.quantity,
                  transactionItemFromDic.toCurrencySubTotalForcalculateWHT,
                  referenceTransactionItemFromDic.quantity
                ),
              };
              mockTransactionItemFromDic.fromCurrencyWHTTotal -= transactionItem.fromCurrencyWHTTotal;
              mockTransactionItemFromDic.fromCurrencyNetTotal -= transactionItem.fromCurrencyNetTotal;
              mockTransactionItemFromDic.fromCurrencyVatTotal -= transactionItem.fromCurrencyVatTotal;
              mockTransactionItemFromDic.fromCurrencyPreVatTotal -= transactionItem.fromCurrencyPreVatTotal;
              mockTransactionItemFromDic.fromCurrencyZeroVatTotal -= transactionItem.fromCurrencyZeroVatTotal;
              mockTransactionItemFromDic.fromCurrencyVatExemptedTotal -= transactionItem.fromCurrencyVatExemptedTotal;
              mockTransactionItemFromDic.fromCurrencySubTotalForcalculateWHT -=
                transactionItem.fromCurrencySubTotalForcalculateWHT;
              mockTransactionItemFromDic.toCurrencyWHTTotal -= transactionItem.toCurrencyWHTTotal;
              mockTransactionItemFromDic.toCurrencyNetTotal -= transactionItem.toCurrencyNetTotal;
              mockTransactionItemFromDic.toCurrencyVatTotal -= transactionItem.toCurrencyVatTotal;
              mockTransactionItemFromDic.toCurrencyPreVatTotal -= transactionItem.toCurrencyPreVatTotal;
              mockTransactionItemFromDic.toCurrencyZeroVatTotal -= transactionItem.toCurrencyZeroVatTotal;
              mockTransactionItemFromDic.toCurrencyVatExemptedTotal -= transactionItem.toCurrencyVatExemptedTotal;
              mockTransactionItemFromDic.toCurrencySubTotalForcalculateWHT -=
                transactionItem.toCurrencySubTotalForcalculateWHT;

              mockTransactionItemList.push(transactionItem);
            }

            transactionItemList.push(...mockTransactionItemList);
          }
        }
      });
    }
  }

  return transactionItemList;
};

export const CalculateRuleOfThreeReconcileTransaction = (quantityTotal, amountTotal, quantity) => {
  return quantityTotal !== 0 ? ((amountTotal * quantity) / quantityTotal).ToAccountingRoundUpNumber() : 0;
};

export const RecheckDiffTransactionItem = (mockTransactionItemList, mockTransactionItemFromDic) => {
  if (mockTransactionItemFromDic.fromCurrencyWHTTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].fromCurrencyWHTTotal +=
      mockTransactionItemFromDic.fromCurrencyWHTTotal;
  }

  if (mockTransactionItemFromDic.fromCurrencyNetTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].fromCurrencyNetTotal +=
      mockTransactionItemFromDic.fromCurrencyNetTotal;
  }

  if (mockTransactionItemFromDic.fromCurrencyVatTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].fromCurrencyVatTotal +=
      mockTransactionItemFromDic.fromCurrencyVatTotal;
  }

  if (mockTransactionItemFromDic.fromCurrencyPreVatTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].fromCurrencyPreVatTotal +=
      mockTransactionItemFromDic.fromCurrencyPreVatTotal;
  }

  if (mockTransactionItemFromDic.fromCurrencyZeroVatTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].fromCurrencyZeroVatTotal +=
      mockTransactionItemFromDic.fromCurrencyZeroVatTotal;
  }

  if (mockTransactionItemFromDic.fromCurrencyVatExemptedTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].fromCurrencyVatExemptedTotal +=
      mockTransactionItemFromDic.fromCurrencyVatExemptedTotal;
  }

  if (mockTransactionItemFromDic.fromCurrencySubTotalForcalculateWHT !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].fromCurrencySubTotalForcalculateWHT +=
      mockTransactionItemFromDic.fromCurrencySubTotalForcalculateWHT;
  }

  if (mockTransactionItemFromDic.toCurrencyWHTTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].toCurrencyWHTTotal +=
      mockTransactionItemFromDic.toCurrencyWHTTotal;
  }

  if (mockTransactionItemFromDic.toCurrencyNetTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].toCurrencyNetTotal +=
      mockTransactionItemFromDic.toCurrencyNetTotal;
  }

  if (mockTransactionItemFromDic.toCurrencyVatTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].toCurrencyVatTotal +=
      mockTransactionItemFromDic.toCurrencyVatTotal;
  }

  if (mockTransactionItemFromDic.toCurrencyPreVatTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].toCurrencyPreVatTotal +=
      mockTransactionItemFromDic.toCurrencyPreVatTotal;
  }

  if (mockTransactionItemFromDic.toCurrencyZeroVatTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].toCurrencyZeroVatTotal +=
      mockTransactionItemFromDic.toCurrencyZeroVatTotal;
  }

  if (mockTransactionItemFromDic.toCurrencyVatExemptedTotal !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].toCurrencyVatExemptedTotal +=
      mockTransactionItemFromDic.toCurrencyVatExemptedTotal;
  }

  if (mockTransactionItemFromDic.toCurrencySubTotalForcalculateWHT !== 0) {
    mockTransactionItemList[mockTransactionItemList.length - 1].toCurrencySubTotalForcalculateWHT +=
      mockTransactionItemFromDic.toCurrencySubTotalForcalculateWHT;
  }
};

export const GetReferenceTransactionItemDicGroupByReferenceTransactionItemId = (referenceTransactionItemDic) => {
  const referenceTransactionItemDicGroupByReferenceTransactionItemId = new Map();
  if (referenceTransactionItemDic && referenceTransactionItemDic.size > 0) {
    referenceTransactionItemDic.forEach((value, key) => {
      if (value.referenceTransactionItemList && value.referenceTransactionItemList.length) {
        for (const referenceTransactionItem of value.referenceTransactionItemList) {
          if (
            referenceTransactionItemDicGroupByReferenceTransactionItemId.has(
              referenceTransactionItem.referenceTransactionItemId
            )
          ) {
            const referenceTransactionItemListFromDic =
              referenceTransactionItemDicGroupByReferenceTransactionItemId.get(
                referenceTransactionItem.referenceTransactionItemId
              );
            referenceTransactionItemListFromDic.push({ ...referenceTransactionItem });
          } else {
            referenceTransactionItemDicGroupByReferenceTransactionItemId.set(
              referenceTransactionItem.referenceTransactionItemId,
              [{ ...referenceTransactionItem }]
            );
          }
        }
      }
    });
  }

  return referenceTransactionItemDicGroupByReferenceTransactionItemId;
};

export const GetTransactionItemListDic = (transactionItemList) => {
  const transactionItemListDic = new Map();
  if (transactionItemList && transactionItemList.length > 0) {
    for (const transactionItem of transactionItemList) {
      transactionItemListDic.set(transactionItem.id, transactionItem);
    }
  }
  return transactionItemListDic;
};

export const ReconcileReferenceTransactionItem = (transactionItem, referenceTransactionItemFromDic) => {
  if (referenceTransactionItemFromDic.quantityTotal > 0) {
    if (referenceTransactionItemFromDic.quantityTotal >= transactionItem.remainingQuantity) {
      referenceTransactionItemFromDic.quantityTotal -= transactionItem.remainingQuantity;
    } else {
      referenceTransactionItemFromDic.quantityTotal = 0;
    }
    if (
      referenceTransactionItemFromDic.transactionItemList &&
      referenceTransactionItemFromDic.transactionItemList.length > 0
    ) {
      let transactionItemQuantity = transactionItem.remainingQuantity;
      for (const item of referenceTransactionItemFromDic.transactionItemList) {
        if (transactionItemQuantity > 0 && item.quantity > 0) {
          const referenceTransactionItem = {
            referenceTransactionItemId: item.referenceTransactionItemId,
            transactionItemId: transactionItem.id,
            quantity: 0,
          };
          if (transactionItemQuantity === item.quantity) {
            referenceTransactionItem.quantity = transactionItemQuantity;
            item.quantity = 0;
            transactionItemQuantity = 0;
          } else if (transactionItemQuantity < item.quantity) {
            referenceTransactionItem.quantity = transactionItemQuantity;
            item.quantity = item.quantity - transactionItemQuantity;
            transactionItemQuantity = 0;
          } else if (transactionItemQuantity > item.quantity) {
            referenceTransactionItem.quantity = item.quantity;
            transactionItemQuantity = transactionItemQuantity - item.quantity;
            item.quantity = 0;
          }
          referenceTransactionItemFromDic.referenceTransactionItemList.push(referenceTransactionItem);
        }
      }
    }
  }
};

export const GetReferenceTransactionItemDic = (referenceTransaction) => {
  const referenceTransactionItemDic = new Map();
  if (referenceTransaction.transactionItemList && referenceTransaction.transactionItemList.length > 0) {
    for (const transactionItem of referenceTransaction.transactionItemList) {
      const keyValue = GetKeyValueTransactionItemForReconcile(transactionItem);
      if (referenceTransactionItemDic.has(keyValue)) {
        const transactionItemFromDic = referenceTransactionItemDic.get(keyValue);
        transactionItemFromDic.quantityTotal += transactionItem.remainingQuantity;
        transactionItemFromDic.transactionItemList.push({
          referenceTransactionItemId: transactionItem.id,
          quantity: transactionItem.remainingQuantity,
        });
      } else {
        referenceTransactionItemDic.set(keyValue, {
          quantityTotal: transactionItem.remainingQuantity,
          referenceTransactionItemList: [],
          transactionItemList: [
            { referenceTransactionItemId: transactionItem.id, quantity: transactionItem.remainingQuantity },
          ],
        });
      }
    }
  }
  return referenceTransactionItemDic;
};

export const GetKeyValueTransactionItemForReconcile = (transactionItem) => {
  return `${transactionItem.productTemplateId.ToNumber()}-${transactionItem.accountId.ToNumber()}-${transactionItem.fromCurrencyPriceWithTransactionDiscount.ToNumber()}-${transactionItem.vatType.ToNumber()}`;
};

export function ValidatePartialQuotationItemTypeTransactionItem(
  transactionItem,
  transactionType,
  financeType,
  transactionItemType,
  expenseType,
  settingQuotationPartial
) {
  transactionItem.amount.alertMessage = "";
  transactionItem.price.alertMessage = "";
  transactionItem.discount.alertMessage = "";

  const documentName =
    financeType === Enums.FinanceType.InFlow
      ? i18n.t("Quotation_LowerCase")
      : transactionItemType === Enums.TransactionItemType.Asset || expenseType === Enums.ExpenseType.PurchaseAsset
      ? i18n.t("Purchase_Order_Asset_LowerCase")
      : i18n.t("Purchase_Order_LowerCase");

  if (transactionItem.amount.validateError === false) {
    switch (settingQuotationPartial.editAmountType) {
      case Enums.SettingPartialQuotationEditType.None:
        if (transactionItem.amount.value.ToNumber() !== transactionItem.referenceAmount.ToNumber()) {
          transactionItem.amount.validateError = true;
          transactionItem.amount.alertMessage = i18n.t("Cannot_Input_Over_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanIncreaseOnly:
        if (transactionItem.amount.value.ToNumber() < transactionItem.referenceAmount.ToNumber()) {
          transactionItem.amount.validateError = true;
          transactionItem.amount.alertMessage = i18n.t("Cannot_Input_Under_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanDecreaseOnly:
        if (transactionItem.amount.value.ToNumber() > transactionItem.referenceAmount.ToNumber()) {
          transactionItem.amount.validateError = true;
          transactionItem.amount.alertMessage = i18n.t("Cannot_Input_Over_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanEdit:
        break;
    }
  }

  if (transactionItem.price.validateError === false) {
    switch (settingQuotationPartial.editPriceType) {
      case Enums.SettingPartialQuotationEditType.None:
        if (transactionItem.price.value.ToNumber() !== transactionItem.referencePrice.ToNumber()) {
          transactionItem.price.validateError = true;
          transactionItem.price.alertMessage = i18n.t("Cannot_Input_Over_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanIncreaseOnly:
        if (transactionItem.price.value.ToNumber() < transactionItem.referencePrice.ToNumber()) {
          transactionItem.price.validateError = true;
          transactionItem.price.alertMessage = i18n.t("Cannot_Input_Under_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanDecreaseOnly:
        if (transactionItem.price.value.ToNumber() > transactionItem.referencePrice.ToNumber()) {
          transactionItem.price.validateError = true;
          transactionItem.price.alertMessage = i18n.t("Cannot_Input_Over_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanEdit:
        break;
    }
  }

  if (transactionItem.discount.validateError === false) {
    switch (settingQuotationPartial.editDiscountType) {
      case Enums.SettingPartialQuotationEditType.None:
        if (transactionItem.discount.value.ToNumber() !== transactionItem.referenceDiscount.ToNumber()) {
          transactionItem.discount.validateError = true;
          transactionItem.discount.alertMessage = i18n.t("Cannot_Input_Over_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanIncreaseOnly:
        if (transactionItem.discount.value.ToNumber() < transactionItem.referenceDiscount.ToNumber()) {
          transactionItem.discount.validateError = true;
          transactionItem.discount.alertMessage = i18n.t("Cannot_Input_Under_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanDecreaseOnly:
        if (transactionItem.discount.value.ToNumber() > transactionItem.referenceDiscount.ToNumber()) {
          transactionItem.discount.validateError = true;
          transactionItem.discount.alertMessage = i18n.t("Cannot_Input_Over_Partial_Quotation_Item", {
            documentName: documentName,
          });
        }
        break;
      case Enums.SettingPartialQuotationEditType.CanEdit:
        break;
    }
  }
}

const SetPaymentPndType = (transaction) => {
  if (
    transaction &&
    !transaction.isNotAuto &&
    transaction.payment &&
    transaction.payment.paymentGroupList &&
    transaction.payment.paymentGroupList.length > 0
  ) {
    const paymentGroup = transaction.payment.paymentGroupList[0];
    const paymentInOutFlowType = paymentHelper.GetPaymentInOutFlowType(transaction);
    if (paymentInOutFlowType === Enums.PaymentInOutFlowType.CashOut && paymentGroup.whtPayment) {
      if (paymentGroup.whtPayment.isWht && paymentGroup.whtPayment.whtAmount.ToNumber() > 0) {
        const getAccountListForMap = store.getters.GetAccountListForMap;
        paymentGroup.whtPayment.pndTypeId = paymentHelper.GetSuggestionPndType(transaction, getAccountListForMap);
      } else {
        paymentGroup.whtPayment.pndTypeId = Enums.PndType.None;
      }
    }
  }
};

export function DisablePartialQuotationItem(transactionItem) {
  transactionItem.productTemplate.disabled = true;
  transactionItem.fixedAssetTemplate.disabled = true;
  transactionItem.account.disabled = true;
  transactionItem.description.disabled = true;
  transactionItem.amount.disabled = true;
  transactionItem.price.disabled = true;
  transactionItem.discount.disabled = true;
  transactionItem.vatTypeId.disabled = true;
  transactionItem.itemWht.disabled = true;

  transactionItem.description.text = transactionItem.referenceDescription;
  transactionItem.amount.value = (0).ToPeakTransactionItemFormat();
  transactionItem.price.value = (0).ToPeakTransactionItemFormat();
  transactionItem.discount.value = (0).ToPeakTransactionItemFormat();
  transactionItem.discount.discountTypeId = Enums.DiscountType.Currency;
}

export function UnDisablePartialQuotationItem(
  transactionItem,
  quotationReferenceTransactionType,
  settingQuotationPartial,
  quotationReferenceTransactionPercent = -1
) {
  transactionItem.description.disabled = false;
  transactionItem.vatTypeId.disabled = false;
  transactionItem.itemWht.disabled = false;

  transactionItem.description.text = transactionItem.referenceDescription;
  transactionItem.amount.value = transactionItem.referenceAmount;
  transactionItem.price.value = transactionItem.referencePrice;
  transactionItem.discount.value = transactionItem.referenceDiscount;
  transactionItem.discount.discountTypeId = transactionItem.referenceDiscountType;

  switch (quotationReferenceTransactionType) {
    case Enums.QuotationReferenceTransactionType.Default:
      transactionItem.productTemplate.disabled = false;
      transactionItem.fixedAssetTemplate.disabled = false;
      transactionItem.account.disabled = false;
      transactionItem.amount.disabled = false;
      transactionItem.price.disabled = false;
      transactionItem.discount.disabled = false;
      break;
    case Enums.QuotationReferenceTransactionType.TransactionItem:
      if (settingQuotationPartial && settingQuotationPartial.isActive) {
        transactionItem.amount.disabled =
          settingQuotationPartial.editAmountType === Enums.SettingPartialQuotationEditType.None;
        transactionItem.price.disabled =
          settingQuotationPartial.editPriceType === Enums.SettingPartialQuotationEditType.None;
        transactionItem.discount.disabled =
          settingQuotationPartial.editDiscountType === Enums.SettingPartialQuotationEditType.None;
      }
      break;
    case Enums.QuotationReferenceTransactionType.Percent:
      transactionItem.price.disabled = false;
      transactionItem.discount.disabled = false;

      const { price, discount } = GetCalculatedPartialQuotationItemTypePercent(
        transactionItem.price.value,
        transactionItem.discount.value,
        transactionItem.discount.discountTypeId,
        quotationReferenceTransactionPercent
      );

      transactionItem.price.value = price;
      transactionItem.discount.value = discount;
      break;
  }
}
export function GetPartialQuotationItemAddItemButtonHoverLabel(
  transactionType,
  financeType,
  transactionItemType,
  expenseType
) {
  let documentName = "";
  let referenceDocumentName = "";

  if (financeType === Enums.FinanceType.InFlow) {
    referenceDocumentName = i18n.t("Quotation_LowerCase");

    switch (transactionType) {
      case Enums.TransactionType.Invoice:
        documentName = i18n.t("Invoice_LowerCase");
        break;
      case Enums.TransactionType.Deposit:
        documentName = i18n.t("Deposit_Receipt_LowerCase");
        break;
      case Enums.TransactionType.Receipt:
        documentName = i18n.t("Receipt_LowerCase");
        break;
    }
  } else if (financeType === Enums.FinanceType.OutFlow) {
    referenceDocumentName =
      transactionItemType === Enums.TransactionItemType.Asset || expenseType === Enums.ExpenseType.PurchaseAsset
        ? i18n.t("Purchase_Order_Asset_LowerCase")
        : i18n.t("Purchase_Order_LowerCase");

    switch (transactionType) {
      case Enums.TransactionType.Invoice:
        documentName =
          transactionItemType === Enums.TransactionItemType.Asset || expenseType === Enums.ExpenseType.PurchaseAsset
            ? i18n.t("PurchaseAsset_LowerCase")
            : i18n.t("PurchaseInventory_LowerCase");
        break;
      case Enums.TransactionType.Deposit:
        documentName = i18n.t("Deposit_Payment_LowerCase");
        break;
      case Enums.TransactionType.GoodsReceipt:
        documentName = i18n.t("Goods_Receipt_LowerCase");
        break;
      case Enums.TransactionType.InvoiceReceipt:
        documentName = i18n.t("Invoice_Receipt_LowerCase");
        break;
    }
  }

  return i18n.t("Add_New_Item_In_Create_Partial_Quotation_Warning", {
    documentName: documentName,
    referenceDocumentName: referenceDocumentName,
  });
}

export function ValidateTransactionReferenceQuotation(transaction) {
  let isValidateError = false;

  const isCanPartialQuotationTransaction = [
    Enums.TransactionType.Invoice,
    Enums.TransactionType.Deposit,
    Enums.TransactionType.Receipt,
    Enums.TransactionType.InvoiceReceipt,
    Enums.TransactionType.GoodsReceipt,
  ].includes(transaction.transactionType);
  const isReferenceQuotation =
    transaction.reference.referenceTypeId === Enums.TransactionType.Quotation && transaction.reference.referenceId > 0;

  if (isCanPartialQuotationTransaction && isReferenceQuotation) {
    isValidateError = !CheckTransactionItemIsNotEmpty(transaction);
  }

  return isValidateError;
}

export function IsShowCheckBoxProduct(
  transaction,
  transactionItem,
  isCreditNoteReferenceTransaction,
  createDocumentType
) {
  let isShow = true;

  switch (createDocumentType) {
    case Enums.CreateDocumentType.OldForm:
    case Enums.CreateDocumentType.NewForm:
      const isHideCheckBox = transactionItem.checked.hidden;
      const isSelectedOptionReturnStock = transaction.returnStock?.value.id === Enums.ReturnStockType.Return;
      const isNormalItem = !transactionItem.isDescriptionOnly;
      const isNotReturnStockItem = !transactionItem.isReturnStock && isNormalItem;
      const isZeroReferencePriceItem = transactionItem.referencePrice?.ToNumber() === 0 && isNormalItem;

      if (isHideCheckBox) {
        isShow = false;
      } else if (
        isCreditNoteReferenceTransaction &&
        ((isSelectedOptionReturnStock && isNotReturnStockItem) || isZeroReferencePriceItem)
      ) {
        isShow = false;
      }
      break;
  }

  return isShow;
}

export default {
  //#region Action for transaction
  OnChangeTransactionItem(transaction) {
    SetTransactionSummary(transaction);
    CheckErrorValueInput(transaction);
    SetPaymentPndType(transaction);
  },
  OnHumanChangeTransactionItem(transaction) {
    transaction.isHumanChange = true;
    transaction.isNotAuto = false;
    if (!(transaction.transactionType == Enums.TransactionType.CreditNote && transaction.reference.referenceId > 0)) {
      transaction.issueTaxInvoice.isNotAuto = false;
    }
    SetTransactionSummary(transaction);
    CheckErrorValueInput(transaction);
    SetPaymentPndType(transaction);
  },
  OnHumanEvent(transaction) {
    transaction.isNotAuto = false;
  },
  OnChangeWhtPayment({ transaction, paymentGroup, isFromEvent = false, isReturnWhtAmountToPayment = false }) {
    paymentHelper.CalculateWhtAmount(
      transaction.transactionSummary.netAmount.ToNumber(),
      transaction.transactionSummary.subTotalForCalculateWht,
      paymentGroup
    );
    paymentHelper.OnChangeWht(paymentGroup, isFromEvent, isReturnWhtAmountToPayment);
    paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
    CheckErrorValueInput(transaction);
  },
  OnChangePaymentGroup(transaction) {
    paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
    CheckErrorValueInput(transaction);
  },
  CheckErrorValueInputForCreateTransaction(transaction) {
    CheckErrorValueInput(transaction);
  },
  CheckErrorPaymentGroup(transaction) {
    CheckErrorValueInput(transaction);
  },
  SelectedPricingProductOnTransactionItem(transaction, input) {
    if (input.pricingProductModel && input.pricingProductModel.productTemplateId > 0) {
      transaction.transactionItemList[input.index].pricingProductModel = input.pricingProductModel;
    } else {
      transaction.transactionItemList[input.index].pricingProductModel = null;
    }
  },
  SetTransactionNumber(transaction, transactionNumber) {
    transaction.number.value = transactionNumber;
  },
  SetTransactionNumberValidateError(transaction, showError) {
    transaction.number.validateError = showError;
  },
  UpdateIsNotAutoTransactionItemList(transaction, transactionItemList) {
    if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.productTemplate.id > 0) {
          transactionItem.productTemplate.isNotAuto = true;
        }
        if (transactionItem.account.id > 0) {
          transactionItem.account.isNotAuto = true;
        }
      }
    }
    transaction.transactionItemList = transactionItemList;
  },
  //#endregion
  GetCreateTransactionItemDefualt(
    transactionType,
    financeType,
    expenseType = Enums.ExpenseType.None,
    transactionItemType = Enums.TransactionItemType.None
  ) {
    return GetCreateTransactionItemDefualt(transactionType, financeType, expenseType, transactionItemType);
  },
  GetCreateTransactionSummaryDefualt(isEditVatDisabled = false) {
    return GetCreateTransactionSummaryDefualt(isEditVatDisabled);
  },
  CalculatePreVatTotalFromEditVatTransaction(transaction) {
    return CalculatePreVatTotalFromEditVatTransaction(transaction);
  },
  SetTransactionSummary(_transaction) {
    return SetTransactionSummary(_transaction);
  },
  SetIssueTaxInvoiceForImport(_transaction, merchantSetting) {
    return SetIssueTaxInvoiceForImport(_transaction, merchantSetting);
  },
  CheckErrorValueInput(transaction, importType = false) {
    return CheckErrorValueInput(transaction, importType);
  },
  TransactionValidationAndRemoveTransactionItemEmpty(_transaction, triggerAlert = true, isImportTransaction = false) {
    return TransactionValidationAndRemoveTransactionItemEmpty(_transaction, triggerAlert, isImportTransaction);
  },
  GetCreditNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
    return GetCreditNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal);
  },
  GetDebitNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
    return GetDebitNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal);
  },
  TransactionValidationDebitNoteCreditNote(_transaction) {
    return TransactionValidationDebitNoteCreditNote(_transaction);
  },
  TransactionValidationInvoice(_transaction) {
    return TransactionValidationInvoice(_transaction);
  },
  BookmarkValidation(_transaction) {
    return BookmarkValidation(_transaction);
  },
  GetCreateTransactionCurrencySummaryDefualt(isEditVatDisabled = false, disableCurrency = false) {
    return GetCreateTransactionCurrencySummaryDefualt(isEditVatDisabled, disableCurrency);
  },
  GetCreateTransactionItemFromTransactionItem(
    transactionDetailItem,
    transactionType = Enums.TransactionType.None,
    financeType = Enums.FinanceType.None,
    isCanEdit = true,
    expenseType = Enums.ExpenseType.None,
    transactionItemType = Enums.TransactionItemType.None
  ) {
    return GetCreateTransactionItemFromTransactionItem(
      transactionDetailItem,
      transactionType,
      financeType,
      isCanEdit,
      expenseType,
      transactionItemType
    );
  },
  GetCurrencyMenuList() {
    return GetCurrencyMenuList();
  },
  GetCurrencyCodeByUid(_currencyUid) {
    return GetCurrencyCodeByUid(_currencyUid);
  },
  SlideToElementError(transaction) {
    SlideToElementError(transaction);
  },
  GetTransactionItemWhtPercent(whtAmountType) {
    return GetTransactionItemWhtPercent(whtAmountType);
  },
  GetCreateTransactionItemForAIChartOfAccount(
    chartOfAccountId,
    transactionType,
    financeType,
    expenseType = Enums.ExpenseType.None,
    transactionItemType = Enums.TransactionItemType.None
  ) {
    return GetCreateTransactionItemForAIChartOfAccount(
      chartOfAccountId,
      transactionType,
      financeType,
      expenseType,
      transactionItemType
    );
  },
  SetEditAllocationTransaction(allocationTransacionRawList, allocationList, financeType) {
    return SetEditAllocationTransaction(allocationTransacionRawList, allocationList, financeType);
  },
  SetEditAllocationJournal(allocationTransacionRawList, allocationList) {
    return SetEditAllocationJournal(allocationTransacionRawList, allocationList);
  },
  TransactionItemValidation(transactionItem, _transaction, _isImport) {
    return TransactionItemValidation(transactionItem, _transaction, _isImport);
  },
  SetCreateAllocationTransaction(allocationList, isJournal = false) {
    const maxAllocationShow = GetMaxAllocationShowByPackage(isJournal);
    return SetCreateAllocationTransaction(allocationList, maxAllocationShow);
  },
  SetAllocationTransactionByFinanceType(_allocationTransacionRawList, allocationList, financeType) {
    let allocationTransacionRawList = [];

    if (_allocationTransacionRawList && _allocationTransacionRawList.length > 0) {
      _allocationTransacionRawList.forEach((allocationTemplate) => {
        let allocation = allocationList.find((x) => x.id == allocationTemplate.allocationId);
        if (allocation) {
          switch (financeType) {
            case Enums.FinanceType.InFlow:
              if (
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Income ||
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All
              ) {
                allocationTransacionRawList.push(allocationTemplate);
              }
              break;
            case Enums.FinanceType.OutFlow:
              if (
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Expense ||
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All
              ) {
                allocationTransacionRawList.push(allocationTemplate);
              }
              break;
          }
        }
      });
    }

    return allocationTransacionRawList;
  },
  CalculateAllocateDiscountPercent(transactionItemList, transactionDiscount, transactionDiscountType, taxStatus) {
    return CalculateAllocateDiscountPercent(
      transactionItemList,
      transactionDiscount,
      transactionDiscountType,
      taxStatus
    );
  },
  CalculateProductTotalPrice(
    transactionItem,
    allocateDiscountPercent,
    transactionToCurrencyUId,
    transactionExchangeRate,
    transactionRatio,
    transactionTaxStatus,
    isMerchantVat,
    transactionType,
    financeType,
    isCalculateCurrency = true
  ) {
    return CalculateProductTotalPrice(
      transactionItem,
      allocateDiscountPercent,
      transactionToCurrencyUId,
      transactionExchangeRate,
      transactionRatio,
      transactionTaxStatus,
      isMerchantVat,
      transactionType,
      financeType,
      isCalculateCurrency
    );
  },
  ConvertTransactionListDetailForCalculateAllocateDiscountPercent(taxStatus, transactionItemList) {
    const transactionListForCalculateAllocateDiscountPercent = [];
    if (transactionItemList && transactionItemList.length > 0) {
      for (const transactionItem of transactionItemList) {
        let transactionItemForCalculate =
          this.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
        const transactionItemPreVatAmount = ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
          taxStatus,
          transactionItemForCalculate.price,
          transactionItemForCalculate.discount,
          transactionItemForCalculate.discountType,
          transactionItemForCalculate.amount,
          transactionItemForCalculate.vatType
        );
        transactionListForCalculateAllocateDiscountPercent.push({
          netAmount: transactionItemPreVatAmount,
          vatType: transactionItemForCalculate.vatType,
        });
      }
    }
    return transactionListForCalculateAllocateDiscountPercent;
  },
  // model ใหม่สำหรับ deposit
  ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(taxStatus, transactionItemList) {
    const transactionListForCalculateAllocateDiscountPercent = [];
    if (transactionItemList && transactionItemList.length > 0) {
      for (const transactionItem of transactionItemList) {
        let transactionItemForCalculate =
          this.ConvertTransactionItemDetailForCalculateProductTotalPriceNewModel(transactionItem);
        const transactionItemPreVatAmount = ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
          taxStatus,
          transactionItemForCalculate.price,
          transactionItemForCalculate.discount,
          transactionItemForCalculate.discountType,
          transactionItemForCalculate.amount,
          transactionItemForCalculate.vatType
        );
        transactionListForCalculateAllocateDiscountPercent.push({
          netAmount: transactionItemPreVatAmount,
          vatType: transactionItemForCalculate.vatType,
        });
      }
    }
    return transactionListForCalculateAllocateDiscountPercent;
  },
  ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem) {
    const transactionItemPrice = transactionItem.price ? transactionItem.price.ToNumber() : 0;
    const transactionItemDiscount = transactionItem.discount ? transactionItem.discount.ToNumber() : 0;
    const transactionItemDiscountTypeId = transactionItem.discountType
      ? transactionItem.discountType
      : Enums.DiscountType.Currency;
    const transactionItemAmount = transactionItem.amount ? transactionItem.amount.ToNumber() : 0;
    const transactionItemVatType = transactionItem.vatType
      ? transactionItem.vatType
      : Enums.ProductVatType.SevenPercent;

    const transactionItemForCalculateProductTotalPrice = {
      price: transactionItemPrice,
      discount: transactionItemDiscount,
      discountType: transactionItemDiscountTypeId,
      amount: transactionItemAmount,
      vatType: transactionItemVatType,
    };
    return transactionItemForCalculateProductTotalPrice;
  },
  // model ใหม่สำหรับ deposit
  ConvertTransactionItemDetailForCalculateProductTotalPriceNewModel(transactionItem) {
    const transactionItemPrice = transactionItem.toCurrencyPrice ? transactionItem.toCurrencyPrice.ToNumber() : 0;
    const transactionItemDiscount = transactionItem.toCurrencyDiscount
      ? transactionItem.toCurrencyDiscount.ToNumber()
      : 0;
    const transactionItemDiscountTypeId = transactionItem.discountType
      ? transactionItem.discountType
      : Enums.DiscountType.Currency;
    const transactionItemAmount = transactionItem.quantity ? transactionItem.quantity.ToNumber() : 0;
    const transactionItemVatType = transactionItem.vatType
      ? transactionItem.vatType
      : Enums.ProductVatType.SevenPercent;

    const transactionItemForCalculateProductTotalPrice = {
      price: transactionItemPrice,
      discount: transactionItemDiscount,
      discountType: transactionItemDiscountTypeId,
      amount: transactionItemAmount,
      vatType: transactionItemVatType,
    };

    return transactionItemForCalculateProductTotalPrice;
  },
  CheckVatOptions(vatTypeId) {
    let vatOptions = [
      { name: i18n.t("None"), value: Enums.ProductVatType.None },
      { name: "0%", value: Enums.ProductVatType.ZeroPercent },
      { name: "7%", value: Enums.ProductVatType.SevenPercent },
    ];
    let selectVat = vatOptions.find((item) => item.value == vatTypeId);
    if (!selectVat) {
      selectVat = vatOptions[2];
    }
    return selectVat;
  },
  SetAssetToTransactionCreate(transaction, assetTemplate, asset) {
    if (transaction.transactionItemList?.length > 0) {
      let transactionItem = transaction.transactionItemList[0];

      transactionItem.fixedAssetTemplate.code = assetTemplate.assetTemplateCode;
      transactionItem.fixedAssetTemplate.id = assetTemplate.id;
      transactionItem.fixedAssetTemplate.name =
        i18n.locale === Enums.LanguageType.Thai ? assetTemplate.nameTh : assetTemplate.nameEn;
      transactionItem.fixedAssetTemplate.assetAccountId = assetTemplate.assetAccountId;
      transactionItem.description.text = assetTemplate.description;

      transactionItem.fixedAsset.code = asset.uniqueId;
      transactionItem.fixedAsset.id = asset.id;
    }
  },
  SetAssetTemplateToTransactionCreate(transaction, assetTemplate) {
    if (transaction.transactionItemList?.length > 0) {
      let transactionItem = transaction.transactionItemList[0];

      transactionItem.fixedAssetTemplate.code = assetTemplate.assetTemplateCode;
      transactionItem.fixedAssetTemplate.id = assetTemplate.id;
      transactionItem.fixedAssetTemplate.name =
        i18n.locale === Enums.LanguageType.Thai ? assetTemplate.nameTh : assetTemplate.nameEn;
      transactionItem.fixedAssetTemplate.assetAccountId = assetTemplate.assetAccountId;
      transactionItem.description.text = assetTemplate.description;
    }
  },
  SetAssetToTransactionEdit(transaction, input) {
    if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
      transaction.transactionItemList.forEach((transactionItem) => {
        let asset = input.assetList.find((x) => x.id == transactionItem.fixedAsset.id);
        if (asset) {
          let assetTemplate = input.assetTemplateList.find((x) => x.id == asset.assetTemplateId);
          if (assetTemplate) {
            transactionItem.fixedAssetTemplate.code = assetTemplate.assetTemplateCode;
            transactionItem.fixedAssetTemplate.id = assetTemplate.id;
            transactionItem.description.text = assetTemplate.description;

            if (
              transaction.transactionType == Enums.TransactionType.TaxInvoice ||
              (transaction.transactionType == Enums.TransactionType.Receipt &&
                transaction.reference.referenceId > 0 &&
                transaction.reference.referenceTypeId == Enums.ReceiptReferenceType.Invoice)
            ) {
              transactionItem.fixedAsset.code = asset.uniqueId;
              transactionItem.fixedAsset.id = asset.id;
            } else {
              if (asset.saleAssetTransactionId == 0) {
                transactionItem.fixedAsset.code = asset.uniqueId;
                transactionItem.fixedAsset.id = asset.id;
              } else {
                transactionItem.fixedAsset.code = "";
                transactionItem.fixedAsset.id = 0;
              }
            }
          }
        }
      });
    }
  },
  CalculateWithCurrencyUid(currencyAmount, exchangeRates, currencyRatio, toCurrencyUid) {
    return CalculateWithCurrencyUid(currencyAmount, exchangeRates, currencyRatio, toCurrencyUid);
  },
  GetInputMaxMinNumber() {
    return {
      inputMaxNumber: inputMaxNumber,
      inputMinNumber: inputMinNumber,
    };
  },
};
